/// <reference path="../_references.js" />


var
    mInventoryControls = new InventoryControls(),
    mInventoryData = new InventoryData(),
    mPreviousPanelWidth;

function resetContentHoldersInventory(lMasterWidth) {
    "use strict";
    if (lMasterWidth == null) {
        lMasterWidth = $(window).width();
    }
    var lPanelHeight = $('#uInventoryMainContentPanel').height(),
        lButtonBarHeight;

    //check page
    var lCurrent = mStateManager.Hash();

    if (lCurrent.Settings[0] === 'KnownLocations') {
        lButtonBarHeight = $('#uKnownLocationButtonBar').height() + 38;
    } else {
        lButtonBarHeight = $('#uDeviceDetailButtonBar').height();
    }

    setWidth('#uMapPanel', 1);
    setWidth('#uAssignmentHistoryListView', 1);
    setWidth('#uDeviceContactListView', 1);

    setHeight('#uMapPanel', 1);
    setWidth('#uDeviceClusterProfileHolder', 1);
    setWidth('#uKnownLocationDetailsHolder', 1);

    // Enter Iphone mode
    if (lMasterWidth <= 1024) {
        setWidth('#uInventoryListPanel', 300);
        inventoryIphoneResolution();
    }
    else {
        resetContentLargeViewInventory();
    }

    setHeight('#uMapPanel', (lPanelHeight - (lButtonBarHeight - 14)));
}

// STATE MANAGER HANDLERS
function mStateManagerInventory_Init(aPrevious, aCurrent) {
    "use strict";
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        if ((!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null')) {
            mInventoryData.TargetId = parseInt(aCurrent.Settings[2]);
            mStateManager.ChangeSettings(2, null);
        }
        populateElement('uMasterContentHolder', aCurrent.Tab + '.Layout.htm', mStateManagerInventory_OnComplete);
    }
}

function mStateManagerInventoryLayout_Init(aPrevious, aCurrent) {
    "use strict";
    if (applyUserPermissionsNavigation(gPageClassManager.Inventory, aCurrent.Settings[0])) {
        $('.LayoutTab.Selected').removeClass('Selected');
        $('#u' + aCurrent.Tab + 'LayoutTab' + aCurrent.Settings[0]).addClass('Selected');
        if (aCurrent.Settings[0] === 'Devices') {
            $('.DeviceContentMenu').show();
            $('.DeviceClusterContentMenu').hide();
            $('.InventoryAnalysisContentMenu').hide();
            $('.InventoryKnownLocationsContentMenu').hide();
            // allow space for collapsable bar
            //   setWidth('#uInventoryListPanel', 400);
        } else if (aCurrent.Settings[0] === 'InventoryTileAnalysis') {
            $('.DeviceContentMenu').hide();
            $('.DeviceClusterContentMenu').hide();
            $('.InventoryAnalysisContentMenu').show();
            $('.InventoryKnownLocationsContentMenu').hide();
            setWidth('#uInventoryListPanel', 250);
        } else if (aCurrent.Settings[0] === 'KnownLocations') {
            $('.DeviceContentMenu').hide();
            $('.DeviceClusterContentMenu').hide();
            $('.InventoryAnalysisContentMenu').hide();
            $('.InventoryKnownLocationsContentMenu').show();
            setWidth('#uInventoryListPanel', 250);
        } else {
            $('.DeviceContentMenu').hide();
            $('.DeviceClusterContentMenu').show();
            $('.InventoryAnalysisContentMenu').hide();
            $('.InventoryKnownLocationsContentMenu').hide();
            setWidth('#uInventoryListPanel', 250);
        }
        mStateManagerInventoryLayout_OnComplete();
    }
}

function mStateManagerInventoryPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename;
    if (applyUserPermissionsNavigation(gPageClassManager.InventoryDevicesPrimary, aCurrent.Settings[1])) {
        $('#uInventoryMainMenuPanel .Selected').removeClass('Selected');
        if (aCurrent.Settings[0] === 'Devices') {
            $('#uInventoryMainMenuPanel .' + aCurrent.Settings[1] + 'Tab').addClass('Selected');
            lFilename = 'Inventory.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.Layout.htm';
            if (!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null') {
                mInventoryData.TargetId = parseInt(aCurrent.Settings[2]);
                mInventoryControls.DeviceCardViewFilter.filter();
            }
        } else if (aCurrent.Settings[0] === 'InventoryTileAnalysis') {
            $('#uInventoryMainMenuPanel .' + 'InventoryAnalysisTab').addClass('Selected');
            lFilename = 'Inventory.' + aCurrent.Settings[0] + '.Layout.htm';
        } else if (aCurrent.Settings[0] === 'KnownLocations') {
            $('#uInventoryMainMenuPanel .' + 'InventoryKnownLocationsTab').addClass('Selected');
            lFilename = 'Inventory.' + aCurrent.Settings[0] + '.Layout.htm';
        } else {
            $('#uInventoryMainMenuPanel .' + 'DeviceClusterTab').addClass('Selected');
            lFilename = 'Inventory.' + aCurrent.Settings[0] + '.Layout.htm';
        }

        populateElement('uInventoryMainContentPanel', lFilename, mStateManagerInventoryPrimary_OnComplete);
    }
}

function mStateManagerInventorySecondary_Init(aPrevious, aCurrent) {
    "use strict";
    if ((!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null')) {
        mInventoryData.TargetId = parseInt(aCurrent.Settings[2]);
        mStateManager.ChangeSettings(2, null);
        if (aCurrent.Settings[0] === 'Devices') {
            mInventoryControls.DeviceCardViewFilter.filter();
        } else if (aCurrent.Settings[0] === 'KnownLocations') {
            mInventoryControls.KnownLocationsCardViewFilter.filter();
        } else {
            mInventoryControls.CardViewFilter.filter();
        }
    }
}

// LOAD COMPLETE
function mStateManagerInventory_OnComplete() {
    "use strict";
    applyUserPermissions([7, 8, 9, 10, 11, 111, 121]);
    $('#uMasterMenuPanel').show();
    resetContentHolders();
    mStateManagerInventoryLayout_Init(null, mStateManager.Hash());


    // set links
    var lSalesForceOrderLink = veritracks.system.clientSetting("salesforceorderlink")
    var lSalesForceReturnLink = veritracks.system.clientSetting("salesforcereturnlink")


    if (lSalesForceOrderLink) {
        $('#uSalesforceOrder').attr('href', lSalesForceOrderLink);
    } else {
        $('#uSalesforceOrder').hide()
    }
    if (lSalesForceReturnLink) {
        $('#uSalesforceReturns').attr('href', lSalesForceReturnLink);
    } else {
        $('#uSalesforceReturns').hide()
    }

    if (!lSalesForceReturnLink && !lSalesForceOrderLink) {
        $('#uSalesforceLinkHolder').hide();
    }
}

function mStateManagerInventoryLayout_OnComplete() {
    "use strict";
    applyUserPermissions([8, 9, 10, 11, 111, 121]);
    if (mStateManager.Settings()[0] === 'Devices') {
        uInventoryDeviceCardView_Init();
        uInventoryDeviceCardViewFilter_Init();
        gPaginatorFactory_onDevicesDeviceCardViewInit();
        mCache.bind('Devicesupdated', inventoryDevices_Updated, null);
    } else if (mStateManager.Settings()[0] === 'InventoryTileAnalysis') {
        uInventoryTileCardView_Init();
        uInventoryTileCardViewFilter_Init();
        gPaginatorFactory_onInventoryTileAnalysisCardViewInit();
    } else if (mStateManager.Settings()[0] === 'KnownLocations') {
        uKnownLocationsCardView_Init();
        uKnownLocationsCardViewFilter_Init();
        generateInventoryKnownLocationsData();
        gPaginatorFactory_onKnownLocationCardViewInit();
    } else {
        uDeviceClustersCardView_Init();
        mCache.bind('DeviceClustersupdated', inventoryDeviceCluster_Updated, null);
    }

    mStateManagerInventoryPrimary_Init(null, mStateManager.Hash());
    veritracks.system.applyControlState('InventoryDevices', mInventoryControls.DevicesCardView);
    veritracks.system.applyControlState('InventoryDeviceClusters', mInventoryControls.CardView);
    veritracks.system.applyControlState('InventoryDeviceTileAnalysis', mInventoryControls.TileAnalysisCardView);
    veritracks.system.applyControlState('InventoryKnownLocations', mInventoryControls.KnownLocationsCardView);
    //start popup
    uInventoryDevicePopupView_Init();


}

function mStateManagerInventoryPrimary_OnComplete() {
    "use strict";
    applyUserPermissions([8, 9, 10, 11, 111, 121,201]);
    veritracks.system.applyControlState('InventoryDevices', mInventoryControls.DevicesCardView);
    veritracks.system.applyControlState('InventoryDeviceClusters', mInventoryControls.CardView);
    veritracks.system.applyControlState('InventoryDeviceTileAnalysis', mInventoryControls.TileAnalysisCardView);
    veritracks.system.applyControlState('InventoryKnownLocations', mInventoryControls.KnownLocationsCardView);
    if (mStateManager.Settings()[0] === 'Devices') {
        if (mStateManager.Settings()[1] === 'Device') {
            resetContentHoldersInventory();
            uDeviceDetailMap_Init();
            generateInventoryDeviceData();
        } else if (mStateManager.Settings()[1] === 'AssignmentHistory') {
            uAssignmentHistoryListView_Init();
        } else if (mStateManager.Settings()[1] === 'ContactHistory') {
            uDeviceContactListView_Init();
        } else if (mStateManager.Settings()[1] === 'BatteryHistory') {
            uDeviceBatteryChart_Init();
        }

    } else if (mStateManager.Settings()[0] === 'InventoryTileAnalysis') {
        if (!isNullOrUndefined(mInventoryControls.TileAnalysisCardViewFilter)) {
            mInventoryControls.TileAnalysisCardViewFilter.filter();
        }
    } else if (mStateManager.Settings()[0] === 'KnownLocations') {
        mInventoryControls.KnownLocationsCardViewFilter.filter();
        uDeviceDetailMap_Init();
        generateKnownLocation_OnInit();
        if (mInventoryControls.Map) {
            uKnownLocationAddress_OnInit();
        }
    } else {
        uDeviceDetailMap_Init();
        uDeviceClusterDeviceListView_Init();
        uDeviceClusterOffenderListView_Init();
        populateDeviceClusterData();
        populateDeviceClusterZoneData();
    }

    resetContentHolders();
}

// LEAVE
function mStateManagerInventory_Leave(aPrevious, aCurrent) {
    "use strict";
    mInventoryData = new InventoryData();
    mCache.unbind('Devicesupdated', inventoryDevices_Updated);
    mCache.unbind('DeviceClustersupdated', inventoryDeviceCluster_Updated);
    mStateManagerInventoryLayout_Leave(aPrevious, aCurrent);

}

function mStateManagerInventoryLayout_Leave(aPrevious, aCurrent) {
    "use strict";
    if (aPrevious.Settings[0] === 'Devices') {
        if (!isNullOrUndefined(mInventoryControls.ListView)) {
            mInventoryControls.ListView.dispose();
            mInventoryControls.ListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceCardViewFilter)) {
            mInventoryControls.DeviceCardViewFilter.dispose();
            mInventoryControls.DeviceCardViewFilter = null;
        }
        if (!isNullOrUndefined(mInventoryControls.ListViewPaginator)) {
            mInventoryControls.ListViewPaginator.dispose();
            mInventoryControls.ListViewPaginator = null;
        }
        mInventoryControls.chartInstance = null;
        mCache.unbind('Devicesupdated', inventoryDevices_Updated);
    } else {
        if (!isNullOrUndefined(mInventoryControls.CardView)) {
            mInventoryControls.CardView.dispose();
            mInventoryControls.CardView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DevicesCardView)) {
            mInventoryControls.DevicesCardView.dispose();
            mInventoryControls.DevicesCardView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.CardViewFilter)) {
            mInventoryControls.CardViewFilter.dispose();
            mInventoryControls.CardViewFilter = null;
        }
        if (!isNullOrUndefined(mInventoryControls.CardViewPaginator)) {
            mInventoryControls.CardViewPaginator.dispose();
            mInventoryControls.CardViewPaginator = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceListView)) {
            mInventoryControls.DeviceClusterDeviceListView.dispose();
            mInventoryControls.DeviceClusterDeviceListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceEditListView)) {
            mInventoryControls.DeviceClusterDeviceEditListView.dispose();
            mInventoryControls.DeviceClusterDeviceEditListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterEnrolleeListView)) {
            mInventoryControls.DeviceClusterEnrolleeListView.dispose();
            mInventoryControls.DeviceClusterEnrolleeListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterEnrolleeEditListView)) {
            mInventoryControls.DeviceClusterEnrolleeEditListView.dispose();
            mInventoryControls.DeviceClusterEnrolleeEditListView = null;
        }
        if (aPrevious.Settings[0] === 'DeviceClusters') {
            if (!isNullOrUndefined(mInventoryControls.DeviceClusterValidator)) {
                mInventoryControls.DeviceClusterValidator.dispose();
                mInventoryControls.DeviceClusterValidator = null;
            }
        }
        mCache.unbind('Devicesupdated', inventoryDeviceCluster_Updated);
    }
    if (!isNullOrUndefined(mInventoryControls.Map)) {
        mInventoryControls.Map.dispose();
        mInventoryControls.Map = null;
    }

    mStateManagerInventoryPrimary_Leave(aPrevious, aCurrent);
}

function mStateManagerInventoryPrimary_Leave(aPrevious, aCurrent) {
    "use strict";

    if (aPrevious.Settings[1] === 'Device') {
    } else if (aPrevious.Settings[1] === 'AssignmentHistory') {
        if (!isNullOrUndefined(mInventoryControls.DevicesAssignmentListView)) {
            mInventoryControls.DevicesAssignmentListView.dispose();
            mInventoryControls.DevicesAssignmentListView = null;
        }
    } else if (aPrevious.Settings[1] === 'ContactHistory') {
        if (!isNullOrUndefined(mInventoryControls.DevicesContactHistoryListView)) {
            mInventoryControls.DevicesContactHistoryListView.dispose();
            mInventoryControls.DevicesContactHistoryListView = null;
        }
    } else if (aPrevious.Settings[1] === 'BatteryHistory') {
        mInventoryControls.chartInstance = null;
        CloseModal();
    } else {

        if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceListView)) {
            mInventoryControls.DeviceClusterDeviceListView.dispose();
            mInventoryControls.DeviceClusterDeviceListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterEnrolleeListView)) {
            mInventoryControls.DeviceClusterEnrolleeListView.dispose();
            mInventoryControls.DeviceClusterEnrolleeListView = null;
        }
        if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceEditListView)) {
            mInventoryControls.DeviceClusterDeviceEditListView.dispose();
            mInventoryControls.DeviceClusterDeviceEditListView = null;
        }
    }
}

// Update
function deviceClusterUpdateCard() {
    "use strict";

}
// LIST POPULATION
function uDeviceClusterDeviceListView_Init() {
    "use strict";
    var lColumns = null,
        lGrid = null,
        i;

    lColumns = [
        { 'id': 'SerialNumber', 'title': localizeWrapper('cSerialNumber'), 'dataField': 'SerialNumber', 'width': 'autoData', 'minWidth': 150, 'sortable': false, 'cssClass': null, 'formatMethod': null },
        { 'id': 'ProductId', 'title': localizeWrapper('cEnrolleeProduct'), 'dataField': 'ProductId', 'width': 'autoData', 'minWidth': 150, 'sortable': false, 'cssClass': null, 'formatMethod': ProductNameFormatter }
    ];

    mInventoryControls.DeviceClusterDeviceListView = new sumo.controls.ListView('uDeviceClusterDeviceListView', 'uDeviceClusterDeviceListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView' }, lColumns);
}

function uDeviceClusterOffenderListView_Init() {
    "use strict";
    var lColumns = null,
        lGrid = null,
        i;

    lColumns = [
        { 'id': 'FullName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'formatMethod': null },
        { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'formatMethod': null },
        { 'id': 'SerialNumber', 'title': localizeWrapper('cSerialNumber'), 'dataField': 'SerialNumber', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'formatMethod': null }
    ];

    mInventoryControls.DeviceClusterEnrolleeListView = new sumo.controls.ListView('uDeviceClusterOffenderListView', 'uDeviceClusterEnrolleeListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView' }, lColumns);
}

function DeviceEnrollmentDataListConverter(aDeviceList) {
    "use strict";
    var lAssignmentList = getDataItems('CurrentDeviceAssignments'),
        lBuilder = new SumoPredicateBuilder(),
        lDeviceDetail,
        lKey,
        lKeyA,
        lFormattedList = [];
    const DEVICE_REFRESH_ICON_DISPLAY = veritracks.system.clientSetting('DeviceRefreshIconDisplay');
    for (lKey in aDeviceList) {
        if (aDeviceList.hasOwnProperty(lKey)) {
            var lAssignmentQuery = null,
                lEnrollee = null,lDevice = aDeviceList[lKey];
            lDeviceDetail = new DeviceEnrolleeItem(aDeviceList[lKey]);
            if (lDeviceDetail.Status === 4) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('Id', lDeviceDetail.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lAssignmentQuery = query(lAssignmentList, lBuilder.RootExpression);
                if (ObjectLength(lAssignmentQuery) > 1) {
                    lDeviceDetail.EnrolleeName = 'Multiple Enrollees Assigned';
                } else {
                    for (lKeyA in lAssignmentQuery) {
                        if (lAssignmentQuery.hasOwnProperty(lKeyA)) {
                            lEnrollee = getDataItem(lAssignmentQuery[lKeyA].EnrolleeId, "Enrollees");
                            lDeviceDetail.Enrollee = lEnrollee;
                        }
                    }
                    if (!isNullOrUndefined(lEnrollee))
                        lDeviceDetail.EnrolleeName = lEnrollee.LastName + ', ' + lEnrollee.FirstName;
                }
            }
            lDeviceDetail.LastContact = deviceLastContactFormatter(lDeviceDetail.Id);
            if (lDeviceDetail.LastContact != "") {
                lDeviceDetail.DeviceDetailContactDisplay = "";
            }

            if (!isNullOrUndefined(lDeviceDetail.Enrollee)) {
                lDeviceDetail.DeviceDetailEnrolleeDisplay = "";
            }

            if (lDeviceDetail.DualCarrierFlag) {
                lDeviceDetail.DeviceDualCarrierDisplay = 'DualCarrierIconProperty'
            }

            lDeviceDetail.BatteryLevel = deviceBatteryLevelFormatter(lDeviceDetail.Id);
            lDeviceDetail.MessageGap = devicecontactStatusImageFormatter(lDeviceDetail.Id);
            if (DEVICE_REFRESH_ICON_DISPLAY && !isNullOrUndefined(lDevice)) {
                lDeviceDetail.DeviceStatus = deviceRefreshStatusFormatter(lDevice.ServiceStatus);//1 - Refreshed, 2 - Not Refreshed
                lDeviceDetail.DeviceStatusId = lDevice.ServiceStatus;
                lDeviceDetail.DeviceStatusDisplay = 'block';
            }
            lDeviceDetail.ProductName = DeviceProductDetailNameFormatter(lDeviceDetail.Id);
            lDeviceDetail.OrganizationName = DeviceOrganizationDetailFormatter(lDeviceDetail.Id);
            lDeviceDetail.StatusName = DeviceStatusDetailFormatter(lDeviceDetail.Id);
            lFormattedList.push(lDeviceDetail);
        }
    }

    return lFormattedList;
}

function uInventoryDeviceCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lList,
        lKey,
        lDevice,
        lBuilder,
        lSelectedIds = [],
        lData = getDataItems('Devices'),
        lPrimaryColumns = aSender.Columns,
        lSecondaryColumns = [],
        lLastFilterContactDate = aSender.columnValue('LastContact'),
        lDeviceEntolleeData,
        lSortExpression = new SortExpression(),
        lIsEmpty = true;

    for (var key in lPrimaryColumns) {
        if (lPrimaryColumns.hasOwnProperty(key)) {
            if (lPrimaryColumns[key].Id != "LastContact") {
                lSecondaryColumns.push(lPrimaryColumns[key]);
            }
        }
    }//end of for
    aSender.SetSecondaryColumns(lSecondaryColumns);
    aSender.LiveExpressionModifier();

    if (mInventoryData.TargetId === -1) {
        lList = query(lData, aSender.Expression);
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mInventoryData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lList = query(lData, lBuilder.RootExpression);
        mInventoryData.TargetId = -1;
    }
    lSortExpression.addAscendingColumn('SerialNumber');
    if (lList.length > 0) {
        lIsEmpty = false;

        //} else {
        //    mInventoryData.DevicesDirty = lSortExpression.sort(lData);
        //    mActivityNotification.addNotification('No items found.');
    }

    mInventoryData.DevicesDirty = DeviceEnrollmentDataListConverter(lSortExpression.sort(lList));
    if (lLastFilterContactDate != "") {
        mInventoryData.DevicesDirty = uDeviceEnrolleeLastContactFormatter(mInventoryData.DevicesDirty, lLastFilterContactDate);
    }
	mInventoryData.DevicesListViewPaginated = mInventoryControls.ListViewPaginator.paginate(mInventoryData.DevicesDirty);
	mInventoryControls.DevicesCardView.setDataSource(mInventoryData.DevicesListViewPaginated);
	veritracks.system.applyFilterState('InventoryDevices', lIsEmpty);

    for (lKey in mInventoryData.DevicesSelectedIds) {
        if (mInventoryData.DevicesSelectedIds.hasOwnProperty(lKey)) {
            lDevice = lList[mInventoryData.DevicesSelectedIds[lKey]];
            if (!isNullOrUndefined(lDevice)) {
                lSelectedIds.push(mInventoryData.DevicesSelectedIds[lKey]);
            }
        }
    }
    mInventoryData.DevicesSelectedIds = lSelectedIds;
    if (mInventoryData.DevicesSelectedIds.length == 0) {
        if (mInventoryData.DevicesListViewPaginated.length > 0) {
            mInventoryControls.DevicesCardView.selected(mInventoryData.DevicesListViewPaginated[0].Id);
        }
    } else {
        mInventoryControls.DevicesCardView.selected(mInventoryData.DevicesSelectedIds[0]);
    }
    // localize here
	veritracks.localization.localizeTitle('#uInventoryListHolder');
}

function uDeviceEnrolleeLastContactFormatter(aDeviceEnrolleList, aFilterValue) {
    "use strict";
    var lFilterDate,
        lDateContactDate,
        lFilterValue = aFilterValue,
        lDate = new Date(),
        lDirtyList = [];

    for (var key in aDeviceEnrolleList) {
        if (aDeviceEnrolleList.hasOwnProperty(key) && aDeviceEnrolleList[key].LastContact != "") {
            if (!isNullOrUndefined(aDeviceEnrolleList[key].Enrollee)) {
                lDateContactDate = FixSentDate(new Date(aDeviceEnrolleList[key].LastContact), aDeviceEnrolleList[key].Enrollee);
                lFilterDate = FixSentDate(new Date(lDate - lFilterValue), aDeviceEnrolleList[key].Enrollee);
                if (aFilterValue <= (3600 * 672 * 1000)) {
                    if (lDateContactDate > lFilterDate) {
                        lDirtyList.push(aDeviceEnrolleList[key]);
                    }//end of if
                } else {
                    if (lDateContactDate < lFilterDate) {
                        lDirtyList.push(aDeviceEnrolleList[key]);
                    }//end of if
                }//end of if
            }
        }//end of if
    }//end of for

    return lDirtyList;
}

function uInventoryDeviceCardViewFilter_Init() {
    "use strict";

    var lProducts = getDataItems('Products');
    var lBuilder;
    var lPermissionInvUnrecStatus = CheckUserHasPermission(101);

    var lDeviceStatuses = getDataItems('DeviceStatuses');
    var lDeviceNewStatuses = [];

    if (!lPermissionInvUnrecStatus) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', 8, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lDeviceNewStatuses = query(lDeviceStatuses, lBuilder.RootExpression);
    }
    else {
        lDeviceNewStatuses = lDeviceStatuses;
    }

    if (isNullOrUndefined(mInventoryControls.DeviceCardViewFilter)) {
        var lUserPreferences = getUserPreferences(8),
            lParams = {
                'Title': localizeWrapper('cInventoryFindDevices'),
                'Content': '',
                'CssClass': 'DefaultFilter',
                'HideOnFilter': true,
                'OnFilter': uInventoryDeviceCardViewFilter_OnFilter,
                'Columns': [
                { 'Id': 'SerialNumber', 'Title': localizeWrapper('cSerialNumber'), 'Type': 'Text', 'DataField': 'SerialNumber' },
                { 'Id': 'Product', 'Title': localizeWrapper('cEnrolleeProduct'), 'Type': 'Dropdown', 'DataField': 'ProductId', 'DataSource': DeviceProductSortFormatter(), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'Agency', 'Title': localizeWrapper('cEnrolleeAgency'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'Status', 'Title': localizeWrapper('cEnrolleeStatus'), 'Type': 'Dropdown', 'DataField': 'Status', 'DataSource': DeviceStatusSortFormatter(lDeviceNewStatuses), 'LocaleName': 'DeviceStatus', 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'LastContact', 'Title': localizeWrapper('cInventoryLastContact'), 'Type': 'Dropdown', 'DataField': 'LastContact', 'DataSource': DeviceLastContactSortFormatter(), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') }

                ],
                'Settings': null,
                'UserPreferences': lUserPreferences,
                'UserId': gUserDetails.UserId,
                'UserPreferenceType': 8,
                'LocalizableMethod': localizeDataItem
            };

        mInventoryControls.DeviceCardViewFilter = gFilterFactory.createControl('uInventoryListViewFilter', 'uInventoryListFilterHolder', lParams);
    } else {
        mInventoryControls.DeviceCardViewFilter.render();
    }
}

function inventoryDevices_Updated() {
    "use strict";
    mInventoryControls.DevicesCardView.setUpdated(true);
}

function uInventoryDevicesListViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mInventoryData.DevicesDirty)) {
        mInventoryData.DevicesDirty = getDataItems('Devices');
    }
    mInventoryData.DevicesListViewPaginated = aSender.paginate(mInventoryData.DevicesDirty);
    mInventoryControls.DevicesCardView.setDataSource(mInventoryData.DevicesListViewPaginated);
}

function gPaginatorFactory_onDevicesDeviceCardViewInit() {
    "use strict";
    if (isNullOrUndefined(mInventoryControls.ListViewPaginator)) {
        mInventoryControls.ListViewPaginator = new sumo.controls.Paginator('uDevicesListViewPaginator', 'uInventoryPagerHolder', {
            'ItemCount': count(mInventoryData.DevicesClean),
            'ItemsPerPage': gPaginationSettings.InventoryDevicesItems
        });
        //        aSender.createControl('uAgentsCardViewPaginator', 'uAgentsPagerHolder', {
        //            'ItemCount': count(mAgentsData.Dirty),
        //            'ItemsPerPage': 500000
        //        });
        mInventoryControls.ListViewPaginator.bind('pagechanged', uInventoryDevicesListViewPaginator_OnPageChanged);
    } else {
        mInventoryControls.ListViewPaginator.render();
    }
    mInventoryControls.DeviceCardViewFilter.filter();



}

function uInventoryDeviceCardView_OnUpdate() {
    "use strict";
    mInventoryControls.DeviceCardViewFilter.filter();
}

function uInventoryDeviceCardView_OnInit(aSender, aParams, aData) {
    "use strict";
    var i;
    mInventoryControls.DevicesCardView.unbind('databind', uInventoryDeviceCardView_OnInit);
    if (mInventoryData.DevicesSelectedIds.length > 0) {
        for (i = 0; i < mInventoryData.DevicesSelectedIds.length; i++) {
            mInventoryControls.DevicesCardView.selected(mInventoryData.DevicesSelectedIds[i]);
        }
    }
}

function uInventoryDeviceCardView_OnSort(aParams, aSort) {
    "use strict";
    var lDevices = mInventoryData.DevicesDirty,
        lDevicesSortedList = [];

    lDevicesSortedList = aSort.sort(lDevices);
    mInventoryData.DevicesDirty = lDevicesSortedList
    mInventoryControls.DeviceCardViewFilter.filter();

}

function uInventoryTileCardView_Init() {
    "use strict";
    var lColumns = null;

    lColumns = [
        { 'id': 'OrganizationName', 'title': localizeWrapper('cInventoryStatusOrganization'), 'dataField': 'OrganizationId', 'width': 60, 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'TotalDevices', 'title': localizeWrapper('cInventoryTotalDevices'), 'dataField': 'TotalDevices', 'width': 60, 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'Assigned', 'title': localizeWrapper('cInventoryAssignedDevices'), 'dataField': 'Assigned', 'width': 60, 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'UnAssigned', 'title': localizeWrapper('cInventoryUnAssignedDevices'), 'dataField': 'UnAssigned', 'width': 60, 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null }
    ];

    mInventoryControls.TileAnalysisCardView = new sumo.controls.CardView('uInventoryTileAnalysisCardView', 'uInventoryListHolder', {
        'cardTemplate': 'Interface/Inventory.InventoryTileAnalysis.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'OrganizationId', 'isSortable': false, 'Columns': lColumns
    });


    mInventoryControls.TileAnalysisCardView.bind('selectedchanged', uInventoryTileAnalysisCardView_OnSelectChange);
    mInventoryControls.TileAnalysisCardView.bind('update', uInventoryTileAnalysisView_OnUpdate);
    mInventoryControls.TileAnalysisCardView.bind('databind', uInventoryTileAnalysisView_OnInit);

}

function uInventoryTileAnalysisCardView_OnSelectChange(aSender, aKeyValue) {
    "use strict";

    if (!isNullOrUndefined(aKeyValue)) {
        mInventoryData.InventoryTileSelectedIds = []
        mInventoryData.InventoryTileSelectedIds.push(aKeyValue);
    } else {
        mInventoryData.InventoryTileSelectedIds = [];
    }

    PopulateDetailView(mInventoryControls.TileAnalysisCardView.selectedDataItem(), { 'OrganizationId': OrganizationNameFormatter }, 'uInventoryDetail');
    resetContentHoldersInventory();
}

function uInventoryTileAnalysisView_OnUpdate() {
    "use strict";
    if (!isNullOrUndefined(mInventoryControls.TileAnalysisCardView)) {
        mInventoryControls.TileAnalysisCardViewFilter.filter();
    }

}


function uInventoryTileAnalysisView_OnInit() {
    "use strict";
    if (!isNullOrUndefined(mInventoryData.InventoryTileClean) && mInventoryData.InventoryTileClean.length > 0) {
        mInventoryControls.TileAnalysisCardView.selected(mInventoryData.InventoryTileClean[0].OrganizationId);
    }

    mInventoryControls.TileAnalysisCardView.unbind('render', uInventoryTileAnalysisView_OnInit);

}

function sumInitialValue(aDeviceStatusId) {
    "use strict";
    var lValue = 0;
    if ([2, 3, 5, 7, 10].indexOf(aDeviceStatusId) !== -1) {
        return 1;
    } else if (aDeviceStatusId == 4) {
        return 0;
    }
}

function sumSecondaryValue(aDeviceStatusId) {
    "use strict";
    if ([2, 3, 4, 5, 7, 10].indexOf(aDeviceStatusId) !== -1) {
        return 1;
    }
}

function generateInventoryTileAnalysisData(aParams, aData) {
    "use strict";
    var lInventoryTiles = aData,
     lOrganization = null,
     lBuilder = new SumoPredicateBuilder(),
     lShelfRateOrganizationLimit,
     lMyDevices = [],
     lTileAnalysisList = [],
     lDefaultShelfRateLimit = 20,
     lOrgList = [],
     lOrgDevices = [],
     lOrgDevicesCount = 0,
     lActiveDevice = [],
     lActiveDeviceCount = 0,
     lInactiveDevice = [],
     lInactiveDeviceCount = 0,
     lSort = new SortExpression();

    if (isNullOrUndefined(aData)) {
        GetInventoryTiles(generateInventoryTileAnalysisData, Sad);
    } else {

        for (var lorgKey in gUserDetails.OrganizationIds) {
            if (gUserDetails.OrganizationIds.hasOwnProperty(lorgKey)) {

                var lTileObject = new InventoryTileAnalysis();
                lOrganization = getDataItem(gUserDetails.OrganizationIds[lorgKey], 'Organizations');
                lShelfRateOrganizationLimit = checkOrganizationProperty(gUserDetails.OrganizationIds[lorgKey], 'ShelfRateLimit');

                lShelfRateOrganizationLimit = parseInt(lShelfRateOrganizationLimit);

                if (isNaN(lShelfRateOrganizationLimit)) {
                    lShelfRateOrganizationLimit = 0;
                }
                if (lShelfRateOrganizationLimit == 0) {
                    lShelfRateOrganizationLimit = lDefaultShelfRateLimit;
                }
                lTileObject.ShelfRateAllowed = parseFloat(lShelfRateOrganizationLimit + ".00").toFixed(2);;
                lTileObject.OrganizationName = lOrganization.Name;
                lTileObject.OrganizationId = lOrganization.Id;
                /**
                lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.OrganizationIds[lorgKey], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('Name', 'My Unassigned Devices', mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                lInactiveDevice = query(lInventoryTiles, lBuilder.RootExpression);
                for (var inkey in lInactiveDevice) {
                    if (lInactiveDevice.hasOwnProperty(inkey)) {
                        lInactiveDeviceCount += parseInt(lInactiveDevice[inkey].Value);
                    }
                }//end of for

                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.OrganizationIds[lorgKey], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('Name', 'My Assigned Devices', mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lActiveDevice = query(lInventoryTiles, lBuilder.RootExpression);
                lBuilder.Clear();

                for (var akey in lActiveDevice) {
                    if (lActiveDevice.hasOwnProperty(akey)) {
                        lActiveDeviceCount += parseInt(lActiveDevice[akey].Value);
                    }
                }//end of for
                **/
                lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.OrganizationIds[lorgKey], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('Name', 'My BLUtag Shelf Rate', mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lOrgDevices = query(lInventoryTiles, lBuilder.RootExpression);
                lBuilder.Clear();

                //lTileObject.Assigned = parseInt(lInactiveDeviceCount);
                //lTileObject.UnAssigned = parseInt(lActiveDeviceCount);
                // lTileObject.TotalDevices = lTileObject.Assigned + lTileObject.UnAssigned;

                for (var selfKey in lOrgDevices) {
                    if (lOrgDevices.hasOwnProperty(selfKey)) {
                        lTileObject.Assigned = parseInt(lOrgDevices[selfKey].Value2);
                        lTileObject.UnAssigned = parseInt(lOrgDevices[selfKey].Value);
                        lTileObject.TotalDevices = lTileObject.Assigned + lTileObject.UnAssigned;
                        lTileObject.ShelfRate = parseFloat((parseInt(lOrgDevices[selfKey].Value) / parseInt(lOrgDevices[selfKey].Value2)) * 100).toFixed(2);
                        break;
                    }
                }

                if (lTileObject.ShelfRate == "Infinity") {
                    lTileObject.ShelfRate = 100;
                }

                if (isNaN(lTileObject.ShelfRate)) {
                    lTileObject.ShelfRate = 0;
                }
                if (lTileObject.ShelfRate >= lTileObject.ShelfRateAllowed) {
                    lTileObject.ShelfRateExceeded = 'block';
                    lTileObject.ShelfRateExceededFlag = true;
                }

                lTileAnalysisList.push(lTileObject);
                lOrgList.push(gUserDetails.OrganizationIds[lorgKey]);

            }//end of if
            lOrgDevicesCount = 0;
            lActiveDeviceCount = 0;
            lInactiveDeviceCount = 0;
        }//end of for

        lSort.addAscendingColumn("OrganizationName");
        lTileAnalysisList = lSort.sort(lTileAnalysisList);
        mInventoryData.InventoryTileClean = lTileAnalysisList;
        mInventoryControls.TileAnalysisCardView.setDataSource(mInventoryData.InventoryTileClean);
        return;


    }




}

/**
function generateInventoryTileAnalysisData() {
    "use strict";
    var lDevices = getDataItems("Devices"),
      lOrganization = null,
      lBuilder = new SumoPredicateBuilder(),
      lShelfRateOrganizationLimit,
      lMyDevices = [],
      lTileAnalysisList = [],
      lDefaultShelfRateLimit = 20,
      lOrgList = [],
      lOrgDevices = null,
      lActiveDevice = [],
      lInactiveDevice = [],
      lSort = new SortExpression();


    lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lMyDevices = query(lDevices, lBuilder.RootExpression);
    lBuilder.Clear();
    for (var key in lMyDevices) {
        if (lMyDevices.hasOwnProperty(key)) {
            if (lOrgList.indexOf(lMyDevices[key].OrganizationId) == -1) {
                var lTileObject = new InventoryTileAnalysis();
                lOrganization = getDataItem(lMyDevices[key].OrganizationId, 'Organizations');
                lShelfRateOrganizationLimit = checkOrganizationProperty(lMyDevices[key].OrganizationId, 'ShelfRateLimit');

                lShelfRateOrganizationLimit = parseInt(lShelfRateOrganizationLimit);

                if (isNaN(lShelfRateOrganizationLimit)) {
                    lShelfRateOrganizationLimit = 0;
                }
                if (lShelfRateOrganizationLimit == 0) {
                    lShelfRateOrganizationLimit = lDefaultShelfRateLimit;
                }
                lTileObject.ShelfRateAllowed = parseFloat(lShelfRateOrganizationLimit + ".00").toFixed(2);;
                lTileObject.OrganizationName = lOrganization.Name;
                lTileObject.OrganizationId = lOrganization.Id;
                //grab all devices in this org
                lBuilder.AddNewExpressionConditional("OrganizationId", lOrganization.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("ProductId", 103, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lOrgDevices = query(lDevices, lBuilder.RootExpression);
                lBuilder.Clear();
                //grab active devices in this org
                lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("Status", 4, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("ProductId", 103, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lActiveDevice = query(lOrgDevices, lBuilder.RootExpression);
                lBuilder.Clear();
                //grab inactive devices in this org
                lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("Status", 5, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("ProductId", 103, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lInactiveDevice = query(lOrgDevices, lBuilder.RootExpression);
                lBuilder.Clear();

                lTileObject.TotalDevices = count(lOrgDevices);
                lTileObject.Assigned = count(lActiveDevice);
                lTileObject.UnAssigned = count(lInactiveDevice);

                //lTileObject.ShelfRate

                //change the formula to total unassigned / total assigned

                //var lShelfRateValue = 0;
                //var lShelfRateValue2 = 0;
                //for (var lKey in lOrgDevices) {
                 //   if (lOrgDevices.hasOwnProperty(lKey)) {
                 //       lShelfRateValue += sumInitialValue(lOrgDevices[lKey].Status);
                 //       lShelfRateValue2 += sumSecondaryValue(lOrgDevices[lKey].Status);
                  //  }
                //}

                lTileObject.ShelfRate = parseFloat((lTileObject.UnAssigned / lTileObject.Assigned) * 100).toFixed(2);

                if (lTileObject.ShelfRate == "Infinity") {
                    lTileObject.ShelfRate = 100;
                }

                if (isNaN(lTileObject.ShelfRate)) {
                    lTileObject.ShelfRate = 0;
                }
                if (lTileObject.ShelfRate >= lTileObject.ShelfRateAllowed) {
                    lTileObject.ShelfRateExceeded = 'block';
                    lTileObject.ShelfRateExceededFlag = true;
                }

                lTileAnalysisList.push(lTileObject);
                lOrgList.push(lMyDevices[key].OrganizationId);
            }//end of if
        }//end of if
    }//end of for

    lSort.addAscendingColumn("OrganizationName");
    lTileAnalysisList = lSort.sort(lTileAnalysisList);

    return lTileAnalysisList;
}
**/
function uInventoryTileAnalysisFilter_OnFilter(aSender, aExpression) {
    "use strict";

    if (isNullOrUndefined(mInventoryData.InventoryTileDirty)) {
        mInventoryData.InventoryTileDirty = mInventoryControls.TileAnalysisCardView.getDataSource();
    }

    if (!isNullOrUndefined(aExpression)) {
        mInventoryData.InventoryTileClean = query(mInventoryData.InventoryTileDirty, aExpression);
    } else {
        mInventoryData.InventoryTileClean = generateInventoryTileAnalysisData();
    }

    mInventoryControls.TileAnalysisCardView.setDataSource(mInventoryData.InventoryTileClean);

    veritracks.localization.localizeTitle('#uInventoryListHolder');
}

function uInventoryTileCardViewFilter_Init() {
    "use strict";

    if (isNullOrUndefined(mInventoryControls.TileAnalysisCardViewFilter)) {
        var lUserPreferences = getUserPreferences(11),
            lParams = {
                'Title': localizeWrapper('cInventoryFindShelfRate'),
                'Content': '',
                'CssClass': 'DefaultFilter',
                'HideOnFilter': true,
                'OnFilter': uInventoryTileAnalysisFilter_OnFilter,
                'Columns': [
                    { 'Id': 'Agency', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': getDataItems('Organizations'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                     { 'Id': 'ShelfRateExceededFlag', 'Title': localizeWrapper('cShelfRateExceeded'), 'Type': 'Dropdown', 'DataField': 'ShelfRateExceededFlag', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') }

                ],
                'Settings': null,
                'UserPreferences': lUserPreferences,
                'UserId': gUserDetails.UserId,
                'UserPreferenceType': 11
            };

        mInventoryControls.TileAnalysisCardViewFilter = gFilterFactory.createControl('uInventoryTileAnalysisViewFilter', 'uInventoryListFilterHolder', lParams);
    } else {
        mInventoryControls.TileAnalysisCardViewFilter.render();
    }

}

function gPaginatorFactory_onInventoryTileAnalysisCardViewInit() {
    "use strict";

    if (isNullOrUndefined(mInventoryControls.InventoryTilePaginator)) {
        if (isNullOrUndefined(mInventoryData.InventoryTileClean)) {
            mInventoryData.InventoryTileClean = generateInventoryTileAnalysisData();
        }

        mInventoryControls.InventoryTilePaginator = new sumo.controls.Paginator('uInventoryTileAnalysisCardViewPaginator', 'uInventoryPagerHolder', {
            'ItemCount': count(mInventoryData.InventoryTileClean),
            'ItemsPerPage': 10
        });

        mInventoryControls.InventoryTilePaginator.bind('pagechanged', uTileAnalysisCardViewPaginator_OnPageChanged);
    } else {
        mInventoryControls.InventoryTilePaginator.render();
    }

    mInventoryControls.InventoryTilePaginator.trigger('pagechanged');
    mInventoryControls.TileAnalysisCardViewFilter.filter();


}

function uTileAnalysisCardViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mInventoryData.InventoryTileDirty)) {
        mInventoryData.InventoryTileDirty = mInventoryData.InventoryTileClean;
    }

    if (!isNullOrUndefined(mInventoryData.InventoryTileDirty)) {
        var lData = aSender.paginate(mInventoryData.InventoryTileDirty);
        mInventoryControls.TileAnalysisCardView.setDataSource(lData);
    }


}

function uInventoryDeviceCardView_Init() {
	"use strict";
    var lColumns = null,
        lGrid = null,
        i,
        lSortExpression = new SortExpression();


    lColumns = [
        { 'id': 'EnrolleeName', 'title': localizeWrapper('cEnrollee'), 'dataField': 'EnrolleeName', 'width': 60, 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'SerialNumber', 'title': localizeWrapper('cInventorySerialProduct'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'ProductId', 'title': localizeWrapper('cInventorySerialProduct'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'Status', 'title': localizeWrapper('cInventoryStatusOrganization'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'OrganizationId', 'title': localizeWrapper('cInventoryStatusOrganization'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'BatteryLevel', 'title': localizeWrapper('cInventoryBatteryLevel'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': null, 'canResize': false },
        { 'id': 'MessageGap', 'title': localizeWrapper('cInventoryDeviceStatus'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': null, 'canResize': false },
        { 'id': 'LastContact', 'title': localizeWrapper('cInventoryLastContact'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null, 'canResize': false }

    ];

    mInventoryControls.DevicesCardView = new sumo.controls.CardView('uInventoryListView', 'uInventoryListHolder', {
        'cardTemplate': 'Interface/Inventory.Devices.Device.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': false, 'Columns': lColumns
    });

    mInventoryControls.DevicesCardView.bind('selectedchanged', uInventoryDeviceCardView_OnSelectChange);
    mInventoryControls.DevicesCardView.bind('update', uInventoryDeviceCardView_OnUpdate);
    mInventoryControls.DevicesCardView.bind('databind', uInventoryDeviceCardView_OnInit);

}

function DeviceStatusDetailFormatter(aDeviceId) {
    "use strict";
    var lResult = '',
        lDevice = GetDevice(aDeviceId);
    if (!isNullOrUndefined(lDevice)) {
        lResult = DeviceStatusNameFormatter(lDevice.Status) + '<br />' + OrganizationNameFormatter(lDevice.OrganizationId);
    }
    return lResult;
}

function DeviceOrganizationDetailFormatter(aDeviceId) {
    "use strict";
    var lResult = '',
        lDevice = GetDevice(aDeviceId);
    if (!isNullOrUndefined(lDevice)) {
        lResult = OrganizationNameFormatter(lDevice.OrganizationId);
    }
    return lResult;
}

function DeviceProductDetailNameFormatter(aDeviceId) {
    "use strict";
    var lResult = '',
        lDevice = GetDevice(aDeviceId);
    if (!isNullOrUndefined(lDevice)) {
        lResult = ProductNameFormatter(lDevice.ProductId);
    }
    return lResult;
}

function uInventoryDevicePopupView_Init() {
    "use strict";
    GetInventoryTiles(onInventoryTileRead_OnSuccess, Sad);
}

function onInventoryTileRead_OnSuccess(aParams, aData) {
    "use strict";
    var lSelfCalcObj = { "AssignedDeviceCount": 0, "UnAssignedDeviceCount": 0, "SelfRate": 0 },
        lAssigned = 0,
        lBuilder = new SumoPredicateBuilder(),
        lShelfRate = 0,
        lUnAssigned = 0;


    if (!isNullOrUndefined(aData)) {
        mInventoryData.InventoryTileTiles = aData;
        lBuilder.AddNewExpressionConditional('Name', 'My Assigned Devices', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lAssigness = query(aData, lBuilder.RootExpression);
        for (var key in lAssigness) {
            if (lAssigness.hasOwnProperty(key)) {
                lAssigned = lAssigned + parseInt(lAssigness[key].Value);
                lAssigned + lAssigned + parseInt(lAssigness[key].Value2)
            }
        }
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Name', 'My Unassigned Devices', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lUnAssigness = query(aData, lBuilder.RootExpression);
        for (var key in lUnAssigness) {
            if (lUnAssigness.hasOwnProperty(key)) {
                lUnAssigned = lUnAssigned + parseInt(lUnAssigness[key].Value);
                lUnAssigned + lUnAssigned + parseInt(lUnAssigness[key].Value2)
            }
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Name', 'My BLUtag Shelf Rate', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lselfRateAssigness = query(aData, lBuilder.RootExpression);

        var lOrgSelfRateValue = 0;
        var lOrgSelfRateValue2 = 0;
        for (var key in lselfRateAssigness) {

            if (lselfRateAssigness.hasOwnProperty(key)) {
                var lOrgSelfRate = parseInt(lselfRateAssigness[key].Value);
                if (!isNaN(lOrgSelfRate)) {
                    lOrgSelfRateValue = lOrgSelfRateValue + lOrgSelfRate;
                }
                lOrgSelfRate = parseInt(lselfRateAssigness[key].Value2);
                if (!isNaN(lOrgSelfRate)) {
                    lOrgSelfRateValue2 = lOrgSelfRateValue2 + lOrgSelfRate;
                }
            }
        }//ennd of for
        lShelfRate = parseFloat((lOrgSelfRateValue / lOrgSelfRateValue2) * 100).toFixed(2);
    }//end of if


    lSelfCalcObj.AssignedDeviceCount = ' ' + lAssigned;
    lSelfCalcObj.UnAssignedDeviceCount = ' ' + lUnAssigned;
    lSelfCalcObj.SelfRate = ' ' + lShelfRate;

    mInventoryControls.PopupView = new sumo.controls.PopupControl("uInventoryShelfPopUp", "uInventoryTab", {
        "DataSource": [lSelfCalcObj],
        "Html": '<div class="MasterTabIcon InventoryLight16"></div><span class="MasterTabText">' + localizeDataItem('', 'Inventory') + '</span>',
        "CardTemplate": 'Interface/Inventory.Devices.Popup.Card.Template.htm',
    });
}

function gFilterFactory_OnDeviceSummaryInit(aSender, aEvent, aData) {
    "use strict";

    if (isNullOrUndefined(gFilterFactory.Controls['uDeviceSummaryFilter'])) {
        var lParams = {
            'Title': localizeWrapper('cInventoryFindDevices'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uDeviceSummaryFilter_OnFilter,
            'Columns': [
            { 'Id': 'SerialNumber', 'Title': localizeWrapper('cSerialNumber'), 'Type': 'Text', 'DataField': 'SerialNumber' },
            { 'Id': 'Product', 'Title': localizeWrapper('cEnrolleeProduct'), 'Type': 'Dropdown', 'DataField': 'ProductId', 'DataSource': getDataItems('Products'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'Agency', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': getDataItems('Organizations'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'Status', 'Title': localizeWrapper('cEnrolleeStatus'), 'Type': 'Dropdown', 'DataField': 'Status', 'DataSource': getDataItems('DeviceStatuses'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'LocalizableMethod': localizeDataItem
        };

        gFilterFactory.createControl('uDeviceSummaryFilter', 'uInventoryListFilterHolder', lParams);
    }
}

//function gCardViewFactory_OnDeviceClustersInit(aSender, aEvent, aData) {
//    var lParams = {
//        'Title': '',
//        'DataSource': null,
//        'CardTemplate': 'Interface/Inventory.DeviceClusters.Card.Template.htm',
//        'TemplateType': 'uri',
//        'OnSelectedChanged': uDeviceClusterCardView_OnSelectChange,
//        'OnRender': gCardViewFactory_OnRender,
//        'DataConverter': null
//    };
//    gCardViewFactory.createControl(
//        'uDeviceClustersCardView',
//        'uInventoryListHolder',
//        lParams);
//}

function gFilterFactory_OnDeviceClusterInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(9),
        lParams = {
            'Title': localizeWrapper('cInventoryFindBBG'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uDeviceClustersCardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'Name', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'Name' },
                { 'Id': 'Description', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Text', 'DataField': 'Description' }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 9
        };

    mInventoryControls.CardViewFilter = aSender.createControl('uDeviceClustersCardViewFilter', 'uInventoryListFilterHolder', lParams);
}

function uDeviceClustersCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lData,
        lBuilder = new SumoPredicateBuilder(),
        lKey,
        lIsInList = false,
        lIsEmpty;
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mInventoryData.DeviceClustersClean = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);

    if (!isNullOrUndefined(mInventoryData.DeviceClustersClean)) {
        if (mInventoryData.TargetId == -1) {
            mInventoryData.DeviceClustersDirty = query(mInventoryData.DeviceClustersClean, aExpression);
        }
        else {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('Id', mInventoryData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            mInventoryData.DeviceClustersDirty = query(mInventoryData.DeviceClustersClean, lBuilder.RootExpression);
            mInventoryData.TargetId = -1;
        }
        mInventoryData.DeviceClustersPaginated = mInventoryControls.CardViewPaginator.paginate(mInventoryData.DeviceClustersDirty);
		lIsEmpty = (mInventoryData.DeviceClustersPaginated.length === 0);
        //veritracks.system.applyFilterState('InventoryDeviceClusters', lIsEmpty);
        mInventoryControls.CardView.setDataSource(mInventoryData.DeviceClustersPaginated);
        if (mInventoryData.DeviceClustersPaginated.length > 0) {
            for (lKey in mInventoryData.DeviceClustersPaginated) {
                if (mInventoryData.DeviceClustersPaginated.hasOwnProperty(lKey)) {
                    if (lKey === mInventoryData.DeviceClustersSelected) {
                        lIsInList = true;
                        mInventoryControls.CardView.selected(mInventoryData.DeviceClustersSelected);
                        break;
                    }
                }
            }
            if (!lIsInList) {
                mInventoryControls.CardView.selectedIndex(0);
            }
		}
		veritracks.system.applyFilterState('InventoryDeviceClusters', lIsEmpty);
    }
}

function gPaginatorFactory_onDeviceClusterInit() {
    "use strict";
    var lDeviceClusters = [];
    var lBuilder = new SumoPredicateBuilder();


    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lDeviceClusters = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);

    if (isNullOrUndefined(mInventoryData.DeviceClustersClean)) {
        mInventoryData.DeviceClustersClean = lDeviceClusters;
    }

    mInventoryControls.CardViewPaginator = new sumo.controls.Paginator('uDeviceClusterCardViewPaginator', 'uInventoryPagerHolder', {
        'ItemCount': count(lDeviceClusters),
        'ItemsPerPage': gPaginationSettings.InventoryDeviceClustersItems
    });

    //    mInventoryControls.CardViewPaginator = aSender.createControl('uDeviceClusterCardViewPaginator', 'uInventoryPagerHolder', {
    //        'ItemCount': count(getDataItems('DeviceClusters')),
    //        'ItemsPerPage': 500000
    //    });

    mInventoryControls.CardViewPaginator.bind('pagechanged', uDeviceClusterCardViewPaginator_OnPageChanged);
    mInventoryControls.CardViewFilter.filter();
    //mInventoryControls.CardViewPaginator.trigger('pagechanged');
}

function uDeviceClusterCardViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mInventoryData.DeviceClustersDirty)) {
        mInventoryData.DeviceClustersDirty = mInventoryData.DeviceClustersClean;
    }
    if (!isNullOrUndefined(mInventoryData.DeviceClustersDirty)) {
        var lData = aSender.paginate(mInventoryData.DeviceClustersDirty);
        mInventoryControls.CardView.setDataSource(lData);
    }
}

function uDeviceClusterscardView_OnDataBind() {
    "use strict";
    mInventoryControls.CardView.selectedIndex(0);
    mInventoryControls.CardView.unbind('render', uDeviceClusterscardView_OnDataBind);
}

function inventoryDeviceCluster_Updated(aParams, aCache) {
    "use strict";
    if (!isNullOrUndefined(mInventoryControls.CardView)) {
        if (mStateManager.Settings(0)[0] == "DeviceClusters") {
            var lPaginatedData = mInventoryData.DeviceClustersPaginated;

            if (UpdateViewOnNewData(aCache, lPaginatedData)) {
                mInventoryControls.CardView.setUpdated(true);
            }
        } else {
            mInventoryControls.CardView.setUpdated(true);
        }
    }
}

function uInventoryBlueBloxCardView_OnUpdate() {
    "use strict";
    if (!isNullOrUndefined(mInventoryControls.CardViewFilter)) {
        mInventoryControls.CardViewFilter.filter();
    }
}

/************************************/
//Inventory Known Location Card View//
/************************************/
function uKnownLocationsCardView_Init() {
    "use strict";
    mInventoryControls.KnownLocationsCardView = new sumo.controls.CardView('uKnownLocationsCardView', 'uInventoryListHolder', { 'cardTemplate': 'Interface/Inventory.KnownLocations.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView' });
    mInventoryControls.KnownLocationsCardView.bind('selectedchanged', uKnownLocationsCardView_OnSelectChange);
    mInventoryControls.KnownLocationsCardView.bind('update', uKnownLocationsCardView_OnUpdate);
    mInventoryControls.KnownLocationsCardView.bind('databind', uKnownLocationsCardView_OnDataBind);
}

function uKnownLocationsCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mInventoryControls.KnownLocationsCardView.selectedIndex(0);
    mInventoryControls.KnownLocationsCardView.unbind('render', uKnownLocationsCardView_OnDataBind);
}

function uKnownLocationsCardView_OnUpdate() {
    "use strict";
    if (!isNullOrUndefined(mInventoryControls.KnownLocationsCardView)) {
        mInventoryControls.KnownLocationsCardViewFilter.filter();
    }
}

function generateKnownLocation_OnInit() {
    "use strict";
    var lKnownLocation = new KnownLocationCard();

    if (mInventoryControls.KnownLocationsCardView.selectedDataItem()) {

        lKnownLocation = mInventoryControls.KnownLocationsCardView.selectedDataItem();
    }
    PopulateDetailView(lKnownLocation,
        {
            'OrganizationId': OrganizationNameFormatter,
            'OrganizationAddressTypeId': OrganizationAddressTypeFormatter,
            'Radius': zoneRadiusFormatter
        }, 'uKnownLocation');
    resetContentHoldersInventory();


}

function uKnownLocationsCardView_OnSelectChange(aSender, aKeyValue) {
    "use strict";

    uCancelKnownLocation();
    if (aKeyValue && aKeyValue !== -1) {
        $('#uDeleteKnownLocationButton').show();
        $('#uEditKnownLocationButton').show();
        mInventoryData.KnownLocationSelectedIds = []
        mInventoryData.KnownLocationSelectedIds.push(aKeyValue);
        mInventoryData.KnownLocationSelected = aKeyValue;
    } else {
        mInventoryData.KnownLocationSelectedIds = [];
        mInventoryData.KnownLocationSelected = 0;
    }

    generateKnownLocation_OnInit();

    if (mInventoryControls.Map) {
        uKnownLocationAddress_OnInit();
    }

    resetContentHoldersInventory();
}

function uKnownLocationsCardView_OnDataBind() {
    "use strict";
    mInventoryControls.KnownLocationsCardView.selectedIndex(0);
    mInventoryControls.KnownLocationsCardView.unbind('render', uKnownLocationsCardView_OnDataBind);
}

function uKnownLocationsCardViewFilter_Init() {
    "use strict";

    if (isNullOrUndefined(mInventoryControls.KnownLocationsCardViewFilter)) {
        var lUserPreferences = getUserPreferences(11),
            lParams = {
                'Title': localizeWrapper('cInventoryKnownLocations'),
                'Content': '',
                'CssClass': 'DefaultFilter',
                'HideOnFilter': true,
                'OnFilter': uKnownLocationsFilter_OnFilter,
                'Columns': [
                    { 'Id': 'Title', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'Title' },
                    { 'Id': 'Agency', 'Title': localizeWrapper('cEnrolleeAgency'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                ],
                'Settings': null,
                'UserPreferences': lUserPreferences,
                'UserId': gUserDetails.UserId,
                'UserPreferenceType': 11
            };

        mInventoryControls.KnownLocationsCardViewFilter = gFilterFactory.createControl('uInventoryKnownLocationsViewFilter', 'uInventoryListFilterHolder', lParams);
    } else {
        mInventoryControls.KnownLocationsCardViewFilter.render();
    }

}

function gPaginatorFactory_onKnownLocationCardViewInit() {
    "use strict";

    if (isNullOrUndefined(mInventoryData.KnownLocationClean)) {
        mInventoryData.KnownLocationClean = mInventoryData.KnownLocationDirty;
    }
    if (isNullOrUndefined(mInventoryControls.KnownLocationPaginator)) {
        mInventoryControls.KnownLocationPaginator = new sumo.controls.Paginator('uInventoryKnownLocationCardViewPaginator', 'uInventoryPagerHolder', {
            'ItemCount': count(mInventoryData.KnownLocationClean),
            'ItemsPerPage': 10
        });

        mInventoryControls.KnownLocationPaginator.bind('pagechanged', uKnownLocationCardViewPaginator_OnPageChanged);
    } else {
        mInventoryControls.KnownLocationPaginator.render();
    }

    mInventoryControls.KnownLocationPaginator.trigger('pagechanged');
    mInventoryControls.KnownLocationsCardViewFilter.filter();
}

function generateInventoryKnownLocationsData() {
    "use strict";
    var lCardList = [],
        lCard,
        lKnownLocations = getDataItems('OrganizationAddress'),
        lKey,
        lItem,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lKnownLocations = query(lKnownLocations, lBuilder.RootExpression);

    for (lKey in lKnownLocations) {
        if (lKnownLocations.hasOwnProperty(lKey)) {
            lItem = lKnownLocations[lKey];
            lCard = new KnownLocationCard();
            lCard.Title = lItem.Title;
            lCard.Id = lItem.Id;
            lCard.OrganizationName = OrganizationNameFormatter(lItem.OrganizationId);
            lCard.OrganizationId = lItem.OrganizationId;
            lCard.Street1 = lItem.Street1;
            lCard.Street2 = lItem.Street2;
            lCard.City = lItem.City;
            lCard.State = lItem.State;
            lCard.Country = lItem.Country;
            lCard.Radius = lItem.Radius;
            lCard.Zip = lItem.Zip;
            lCard.Latitude = lItem.Latitude;
            lCard.Longitude = lItem.Longitude;
            lCard.OrganizationAddressTypeId = lItem.OrganizationAddressTypeId;
            lCardList.push(lCard);
        }
    }

    mInventoryData.KnownLocationsDirty = lCardList;
}

function uKnownLocationsFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lIsEmpty;

    if (mInventoryData.TargetId === -1) {
        if (!isNullOrUndefined(aExpression)) {
            mInventoryData.KnownLocationClean = query(mInventoryData.KnownLocationsDirty, aExpression);
        } else {
            mInventoryData.KnownLocationClean = mInventoryData.KnownLocationsDirty;
        }
    } else {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mInventoryData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mInventoryData.KnownLocationClean = query(mInventoryData.KnownLocationsDirty, lBuilder.RootExpression);
        mInventoryData.TargetId = -1;
    }

    if (mInventoryData.KnownLocationClean.length === 0) {
        lIsEmpty = (mInventoryData.KnownLocationClean.length === 0);
	}
    veritracks.system.applyFilterState('KnownLocations', lIsEmpty);
    mInventoryData.KnownLocationPaginated = mInventoryControls.KnownLocationPaginator.paginate(mInventoryData.KnownLocationClean);
    mInventoryControls.KnownLocationsCardView.setDataSource(mInventoryData.KnownLocationPaginated);


    veritracks.localization.localizeTitle('#uInventoryListHolder');
}

function uKnownLocationCardViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mInventoryData.KnownLocationsDirty)) {
        mInventoryData.KnownLocationsDirty = generateInventoryKnownLocationsData();
    }

    mInventoryData.KnownLocationPaginated = aSender.paginate(mInventoryData.KnownLocationsDirty);
    mInventoryControls.KnownLocationsCardView.setDataSource(mInventoryData.KnownLocationPaginated);
}

//write
function uSaveKnownLocationButton_OnClick() {
    "use strict";
    if (mInventoryControls.KnownLocationValidator.IsValid()) {
        KnownLocationExitEditMode();
        var lKnownLocation = new KnownLocation();
        var lLatitude = RoundNumber(mInventoryData.EditShape.center.lat(), 7);
        var lLongitude = RoundNumber(mInventoryData.EditShape.center.lng(), 7);
        var lMatch = 1;


        $('#uAddKnownLocationButton').hide();
        $('#uEditKnownLocationButton').hide();
        $('#uSaveKnownLocationButton').show();
        $('#uCancelKnownLocationButton').show();
        $('#uDeleteKnownLocationButton').hide();
        populateFromEditView(lKnownLocation, 'uKnownLocation', 'Edit');

        //Vulnerability Ticket 3250
        lKnownLocation.Title = veritracks.system.encodeHtml(lKnownLocation.Title);
        lKnownLocation.Street1 = veritracks.system.encodeHtml(lKnownLocation.Street1);
        lKnownLocation.Street2 = veritracks.system.encodeHtml(lKnownLocation.Street2);
        lKnownLocation.State = veritracks.system.encodeHtml(lKnownLocation.State);
        lKnownLocation.City = veritracks.system.encodeHtml(lKnownLocation.City);
        lKnownLocation.Country = veritracks.system.encodeHtml(lKnownLocation.Country);

        lKnownLocation.Latitude = RoundNumber(lKnownLocation.Latitude, 7);
        lKnownLocation.Longitude = RoundNumber(lKnownLocation.Longitude, 7);
        lKnownLocation.TransactionId = moment().format("YYYYMMDDHHmmss");
        lKnownLocation.Radius = parseFloat(lKnownLocation.Radius);
        lKnownLocation.Id = parseInt(mInventoryData.KnownLocationEditData.Id);

        if (lLatitude == lKnownLocation.Latitude && lLongitude == lKnownLocation.Longitude) {
            lMatch = 1;
        }
        else {
            lMatch = 0;
            lKnownLocation.Latitude = lLatitude;
            lKnownLocation.Longitude = lLongitude;
        }

        lKnownLocation.PositionMatchesGeocode = lMatch;

        if (isNaN(lKnownLocation.Id)) {
            lKnownLocation.Id = -1;
        }

        WriteSingle(lKnownLocation, knownLocation_OnSuccess, knownLocation_OnFailure, 'KnownLocation');
    }
    resetContentHoldersInventory();
}

function KnownLocationExitEditMode() {
    "use strict";

    $('#uAddKnownLocationButton').show();
    $('#uEditKnownLocationButton').show();
    $('#uSaveKnownLocationButton').hide();
    $('#uCancelKnownLocationButton').hide();
    $('#uDeleteKnownLocationButton').show();
    $('#uKnownLocationMapLocateButton').hide();

    ExitEditMode('uKnownLocationPanel');
}

function uAddKnownLocationButton_OnClick() {
    "use strict";
    $('#uAddKnownLocationButton').hide();
    $('#uEditKnownLocationButton').hide();
    $('#uSaveKnownLocationButton').show();
    $('#uCancelKnownLocationButton').show();
    $('#uDeleteKnownLocationButton').hide();
    $('#uKnownLocationMapLocateButton').show();

    mInventoryData.KnownLocationEditData = new KnownLocation();
    KnownLocationZone_Init();
    PopulateKnownLocationEditData();
    EnterEditMode('uKnownLocationPanel');
    mInventoryControls.KnownLocationValidator = new Validator('uKnownLocationPanel', mRegexValidation);
    mInventoryControls.KnownLocationValidator.IsValid();
    $('#uKnownLocationProfilePanel').show();
    $('#uDeleteKnownLocationButton').hide();
}

function uEditKnownLocationButton_OnClick() {
    "use strict";
    $('#uAddKnownLocationButton').hide();
    $('#uEditKnownLocationButton').hide();
    $('#uSaveKnownLocationButton').show();
    $('#uCancelKnownLocationButton').show();
    $('#uDeleteKnownLocationButton').show();
    $('#uKnownLocationMapLocateButton').show();

    mInventoryData.KnownLocationEditData = mInventoryControls.KnownLocationsCardView.selectedDataItem();
    KnownLocationZone_Init();
    PopulateKnownLocationEditData();
    EnterEditMode('uKnownLocationPanel');
    mInventoryControls.KnownLocationValidator = new Validator('uKnownLocationPanel', mRegexValidation);
}

function KnownLocationZone_Init() {
    "use strict";
    var lZone = new Zone();

    lZone.Type = 1;

    lZone.CenterLatitude = mInventoryData.KnownLocationEditData.Latitude;
    lZone.CenterLongitude = mInventoryData.KnownLocationEditData.Longitude;
    lZone.Radius = mInventoryData.KnownLocationEditData.Radius;
    lZone.Id = mInventoryData.KnownLocationEditData.Id;
    if (lZone.CenterLatitude == 0) {
        var lAddress = mInventoryControls.Map.layerGetDataSource('address');
        if (lAddress) {
            lZone.CenterLatitude = lAddress[0].latitude;
            lZone.CenterLongitude = lAddress[0].longitude;
        }
    }
    mInventoryControls.Map.layerSetDataSource('KnownZones', veritracks.mapping.prepareZoneData([lZone]));
    mInventoryData.EditShape = mInventoryControls.Map.layerGetShape('KnownZones', lZone.Id);
    if (!isNullOrUndefined(mInventoryData.EditShape)) {
        mInventoryData.EditShape.setEditable(true);
    }
    mInventoryControls.Map.layerHide('address');
}

function uCancelKnownLocation() {
    "use strict";
    var lIsEmpty,
    lClass = 'Inventory';

    $('#uAddKnownLocationButton').show();
    $('#uSaveKnownLocationButton').hide();
    $('#uCancelKnownLocationButton').hide();
    $('#uKnownLocationMapLocateButton').hide();

    ExitEditMode('uKnownLocationPanel');
    resetContentHoldersInventory();
}

function uCancelKnownLocationButton_OnClick() {
    "use strict";
    uCancelKnownLocation();
    if (mInventoryData.KnownLocationSelectedIds.length > 0) {
        $('#uDeleteKnownLocationButton').show();
        $('#uEditKnownLocationButton').show();
    }
    uKnownLocationAddress_OnInit();
}

function KnownLocationOrganization_OnChange(aSender) {
    "use strict";
    var lOrganizationId = parseInt(aSender.value);
    var lOrganizationAddresses = [];
    var lAddressTypes = [];
    var lBuilder = new SumoPredicateBuilder();
    var lHome = false;
    var lKey;

    $('#uKnownLocationOrganizationAddressTypeIdEdit').empty();

    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lOrganizationAddresses = query(getDataItems('OrganizationAddress'), lBuilder.RootExpression);

    for (lKey in lOrganizationAddresses) {
        if (lOrganizationAddresses.hasOwnProperty(lKey)) {
            if (lOrganizationAddresses[lKey].OrganizationAddressTypeId == 1) {
                if (mInventoryData.KnownLocationEditData.Id != -1 && mInventoryData.KnownLocationEditData.OrganizationId == lOrganizationId && mInventoryData.KnownLocationEditData.OrganizationAddressTypeId == 1) {

                } else {
                    lHome = true;
                }
            }
        }

    }

    lBuilder.Clear();
    if (lHome) {
        lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    }
    lAddressTypes = query(getDataItems('OrganizationAddressType'), lBuilder.RootExpression);

    var lKey;
    var lTypes = [];
    var lValue = -1;

    for (lKey in lAddressTypes) {
        if (lAddressTypes.hasOwnProperty(lKey)) {
            var lType = lAddressTypes[lKey];
            if (mInventoryData.KnownLocationEditData.OrganizationId == lOrganizationId && mInventoryData.KnownLocationEditData.OrganizationAddressTypeId == lType.Id) {
                lValue = lType.Id;
                lTypes.push(new Option(AddressTypeFormatter(lType.Description), lType.Id, true));
            } else {
                lTypes.push(new Option(AddressTypeFormatter(lType.Description), lType.Id));
            }
        }
    }

    $('#uKnownLocationOrganizationAddressTypeIdEdit').append(lTypes);
    $('#uKnownLocationOrganizationAddressTypeIdEdit').val(lValue);
}

function PopulateKnownLocationEditData() {
    "use strict";

    populateEditView(mInventoryData.KnownLocationEditData,
        [
            {
                'Id': 'OrganizationId',
                'Type': 'Dropdown',
                'DataSource': getDataItems('Organizations'),
                'DataValueField': 'Id',
                'DataTextField': 'Name'
            }
        ],
    {'Title':veritracks.system.decodeHtml,'City': veritracks.system.decodeHtml, 'Country': veritracks.system.decodeHtml,'Street1': veritracks.system.decodeHtml,'Street2': veritracks.system.decodeHtml,'State': veritracks.system.decodeHtml},
    'uKnownLocation',
    'Edit', localizeDataItem);

    if (mInventoryData.KnownLocationEditData) {
        $('#uKnownLocationIdEdit').val(mInventoryData.KnownLocationEditData.Id);
        $('#uKnownLocationLatitudeEdit').val(mInventoryData.KnownLocationEditData.Latitude);
        $('#uKnownLocationLongitudeEdit').val(mInventoryData.KnownLocationEditData.Longitude);
    }

    $('#uKnownLocationOrganizationIdEdit').change();
}

function knownLocation_OnSuccess(aParams, aData) {
    // standard success
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cKnownLocationSaving') + ': ' + aData.Title);
    setDataItem(aData.Id, 'OrganizationAddress', aData);
    //    uKnownLocationsCardView_OnUpdate();
    ExitEditMode('uKnownLocationPanel');
    mInventoryControls.KnownLocationValidator.dispose();
    mInventoryControls.KnownLocationValidator = null;
    generateInventoryKnownLocationsData();

    // setLoadingBarStatus('uKnownLocationWaitingHolder', 'uKnownLocationPanel', false, function () { });
    window.location.hash = 'Inventory.KnownLocations.Device.' + aData.Id.toString();
}

function knownLocation_OnFailure() {
    "use strict";
}

function uKnownLocationAddressEditMapLocateButton_OnClick() {
    "use strict";

    var lAddress = '';
    lAddress += $('#uKnownLocationStreet1Edit').val();
    lAddress += ' ' + $('#uKnownLocationStreet2Edit').val();
    lAddress += ' ' + $('#uKnownLocationCityEdit').val();
    lAddress += ' ' + $('#uKnownLocationStateEdit').val();
    lAddress += ' ' + $('#uKnownLocationZipEdit').val();


    mInventoryControls.Map.locate(lAddress, uKnownLocationAddressMapLocate_Complete);
}

function uKnownLocationAddress_OnInit() {
    "use strict";
    var lKnownLocation;
    var lZone = new Zone();

    lZone.Type = 3;

    if (mInventoryControls.KnownLocationsCardView) {
        lKnownLocation = mInventoryControls.KnownLocationsCardView.selectedDataItem();

        if (lKnownLocation) {
            knownLocationSetAddressMarker(lKnownLocation.Latitude, lKnownLocation.Longitude, lKnownLocation.OrganizationAddressTypeId, lKnownLocation.Radius);
            lZone.CenterLatitude = lKnownLocation.Latitude;
            lZone.CenterLongitude = lKnownLocation.Longitude;
            lZone.Radius = lKnownLocation.Radius = lKnownLocation.Radius;
            mInventoryControls.Map.layerSetDataSource('KnownZones', veritracks.mapping.prepareZoneData([lZone]));
        }
    }

}



function uKnownLocationAddressMapLocate_Complete(aType, aLocation) {
    "use strict";
    var lItem,
        lStreetNumber = '',
        lStreet1 = '',
        lStreet2 = '',
        lCity = '',
        lState = '',
        lZipcode = '',
        lKey,
        lLatitude,
        lLongitude,
        lCountry = '';
    if (aType === 'Geocode') {
        if (aLocation !== null) {
            mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringAddress') + aLocation.formated_address);
            lLatitude = RoundNumber(aLocation.center_latitude, 7);
            lLongitude = RoundNumber(aLocation.center_longitude, 7);
            $('#uKnownLocationLatitudeEdit').val(lLatitude);
            $('#uKnownLocationLongitudeEdit').val(lLongitude);

            veritracks.mapping.setCenter(mInventoryControls.Map, 'KnownZones', mInventoryData.EditShape.sumoId, aLocation.geometry.location);
            mInventoryControls.Map.zoom(18);
            //knownLocationSetAddressMarker(aLocation.geometry.location.lat(), aLocation.geometry.location.lng(), aType);

            var AddressSearch = new Address(aLocation);

            $('#uKnownLocationStreet1Edit').val(AddressSearch.Street1);
            $('#uKnownLocationCityEdit').val(AddressSearch.City);
            $('#uKnownLocationZipEdit').val(AddressSearch.ZipCode);
            $('#uKnownLocationStateEdit').val(AddressSearch.State);
            $('#uKnownLocationCountryEdit').val(AddressSearch.Country);

            if ($('#uOffenderGeocodeCheck').is(':visible')) {
                $('#uOffenderGeocodeCheck').prop('checked', false);
            }
            mInventoryControls.KnownLocationValidator.IsValid();

        } else {
            mActivityNotification.addNotification(localizeWrapper('cDefaultAddressNotGeocoded'));
        }
    } else {
        mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringLatLong') + aLocation.Latitude + ', ' + aLocation.Longitude);
    }
}

function knownLocationSetAddressMarker(aLatitude, aLongitude, aAddressType, aRadius) {
    "use strict";
    var lMarkerData = [],
        lMarker;
    mInventoryControls.Map.setCenter(aLatitude, aLongitude);
    mInventoryControls.Map.zoom(17);
    switch (aAddressType) {
        case 1:
            lMarker = 'Images/Maps/home.png';
            break;
        case 2:
            lMarker = 'Images/Maps/work.png';
            break;
        default:
            lMarker = 'Images/Maps/other.png';
            break;
    }
    lMarkerData.push({
        'latitude': aLatitude,
        'longitude': aLongitude,
        'anchor': { 'x': 12, 'y': 12 },
        'iconUri': lMarker,
        'doHover': false
    });
    mInventoryControls.Map.layerShow('address');
    mInventoryControls.Map.layerSetDataSource('address', lMarkerData);

}

function uDeleteKnownLocationButton_OnClick() {
    "use strict";

    var lKnownLocationId = mInventoryControls.KnownLocationsCardView.selectedDataItem(),
        lKnownLocation = getDataItem(lKnownLocationId.Id, 'OrganizationAddress');

    function knownLocation_OnSuccess(aParams, aData) {
        mActivityNotification.addNotification(localizeWrapper('cKnownLocationDeleting') + ': ' + aData.Title);
        setDataItem(aData.Id, 'OrganizationAddress', aData);
        ExitEditMode('uKnownLocationPanel');
        generateInventoryKnownLocationsData();
        uKnownLocationsFilter_OnFilter();
    }


    lKnownLocation.IsActive = 0;
    WriteSingle(lKnownLocation, knownLocation_OnSuccess, null, null, true);
}

/************************************/
//Inventory Known Location Card View//
/************************************/

function uDeviceClustersCardView_Init() {
    "use strict";
    $('#uInventoryListFilterContent').html('');
    mInventoryControls.CardView = new sumo.controls.CardView('uDeviceClusterCardView', 'uInventoryListHolder', { 'cardTemplate': 'Interface/Inventory.DeviceClusters.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView' });
    mInventoryControls.CardView.bind('selectedchanged', uDeviceClusterCardView_OnSelectChange);
    mInventoryControls.CardView.bind('databind', uDeviceClusterscardView_OnDataBind);
    mInventoryControls.CardView.bind('update', uInventoryBlueBloxCardView_OnUpdate);

    if (isNullOrUndefined(mInventoryControls.CardViewFilter)) {
        gFilterFactory_OnDeviceClusterInit(gFilterFactory, null, null);
    } else {
        mInventoryControls.CardViewFilter.render();
    }
    if (isNullOrUndefined(mInventoryControls.CardViewPaginator)) {
        gPaginatorFactory_onDeviceClusterInit();
    } else {
        mInventoryControls.CardViewPaginator.render();
        mInventoryControls.CardViewPaginator.trigger('pagechanged');
    }

}

// LIST EVENTS
function uDeviceSummaryFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    SelectFirstDeviceItem(aSender, null);
}

function uAssignmentHistoryListView_OnSort(aParams, aSort) {
    "use strict";
    var lAssignmentRecords = mInventoryControls.DevicesAssignmentListView.getDataSource(),
        lAssignmentRecordsSortedList = [];

    lAssignmentRecordsSortedList = aSort.sort(lAssignmentRecords);
    mInventoryControls.DevicesAssignmentListView.setDataSource(lAssignmentRecordsSortedList);
}

function uAssignmentHistoryListView_OnLoad(aParams, aAssignmentList) {
    "use strict";

    FixDates(aAssignmentList);

    if (isNullOrUndefined(mInventoryControls.DevicesAssignmentListView)) {
        var lColumns = [
            { 'id': 'Enrollee', 'title': localizeWrapper('cEnrollee'), 'dataField': 'EnrolleeId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': inventoryEnrolleeNameLinkFormatter },
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'EnrolleeId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': EnrolleePrimaryIdFormatter },
            { 'id': 'Organization', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter },
           // { 'id': 'UserId', 'title': 'Agent Name', 'dataField': 'UserId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': agentNameFormatterByUserId },
            { 'id': 'StartDate', 'title': localizeWrapper('cEnrolleeStartDate'), 'dataField': 'StartDate', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': DisplayLongDateTime },
            { 'id': 'EndDate', 'title': localizeWrapper('cEnrolleeEndDate'), 'dataField': 'EndDate', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': AssignmentEndDateFormatter },
            { 'id': 'ReasonForChange', 'title': localizeWrapper('cEnrolleeChangeReason'), 'dataField': 'ReasonForChange', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': AssignmentChangeReasonFormatter },
            { 'id': 'ChargerReturnStatus', 'title': localizeWrapper('cEnrolleeChargerReturnStatus'), 'dataField': 'ChargerReturnStatus', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'UnAssignedByUserId', 'title': localizeWrapper('cEnrolleeAttemptToRecover'), 'dataField': 'UnAssignedByUserId', 'width': 'autoData', 'minWidth': 130, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': agentNameFormatterByUserId }
        ];

        mInventoryControls.DevicesAssignmentListView = new sumo.controls.ListView('uAssignmentHistoryListView', 'uAssignmentHistoryHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView' }, lColumns);
        mInventoryControls.DevicesAssignmentListView.bind('sort', uAssignmentHistoryListView_OnSort);
    }
    for (var lKey in aAssignmentList) {
        if (aAssignmentList.hasOwnProperty(lKey)) {
            var lEnrollee = getDataItem(aAssignmentList[lKey].EnrolleeId, 'Enrollees');

            if (!isNullOrUndefined(lEnrollee)) {
                aAssignmentList[lKey].StartDate = displayEventInEnrolleeTimeZone(aAssignmentList[lKey].StartDate, lEnrollee);
                aAssignmentList[lKey].EndDate = displayEventInEnrolleeTimeZone(aAssignmentList[lKey].EndDate, lEnrollee);
                aAssignmentList[lKey].ChargerReturnStatus = AssignmentChargerStatusFormatter(aAssignmentList[lKey].EndDate, aAssignmentList[lKey].ChargerReturnStatus);
                aAssignmentList[lKey].UnAssignedByUserId = aAssignmentList[lKey].AttemptRecoverFlag ? aAssignmentList[lKey].UnAssignedByUserId : -1;
            } else {
                aAssignmentList.splice(lKey, 1);
            }
        }
    }
    mInventoryControls.DevicesAssignmentListView.setDataSource(aAssignmentList);
    mInventoryControls.DevicesAssignmentListView.sort();

    if (typeof aParams !== 'undefined' && aParams !== null) {
        var lHolder = $('#uAssignmentHistoryHolder');
        $('<div/>', { 'html': '[multiple selected]', 'class': 'MultipleSelected' }).appendTo(lHolder);
    }
}


function uDeviceContactListView_OnSort(aParams, aSort) {
    "use strict";
    var lDeviceContacts = mInventoryControls.DevicesContactHistoryListView.getDataSource(),
        lDeviceContactsSortedList = [];

    lDeviceContactsSortedList = aSort.sort(lDeviceContacts);
    mInventoryControls.DevicesContactHistoryListView.setDataSource(lDeviceContactsSortedList);
}

function uDeviceContactListView_OnLoad(aParams, aContactList) {
    "use strict";
    FixDates(aContactList);

    if (isNullOrUndefined(mInventoryControls.DevicesContactHistoryListView)) {
        var lColumns = [
            { 'id': 'ContactDate', 'title': localizeWrapper('cEnrolleeDateTime'), 'dataField': 'ContactDate', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': DisplayLongDateTime },
            { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'Status', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': contactStatusImageFormatter },
            { 'id': 'RecordCount', 'title': localizeWrapper('cInventoryRecords'), 'dataField': 'RecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'NumericColumn', 'dataType': 'string', 'formatMethod': null },
            { 'id': 'GpsRecordCount', 'title': localizeWrapper('cInventoryGPS'), 'dataField': 'GpsRecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'NumericColumn', 'dataType': 'number', 'formatMethod': null },
            { 'id': 'PercentGps', 'title': localizeWrapper('cInventoryPercentGPS'), 'dataField': 'PercentGps', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': 'NumericColumn', 'dataType': 'number', 'formatMethod': DisplayPercent },
            { 'id': 'BatteryLevel', 'title': localizeWrapper('cInventoryBatteryLevel'), 'dataField': 'BatteryLevel', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': inventoryBatteryLevelFormatter },
            { 'id': 'BatteryVoltage', 'title': localizeWrapper('cInventoryBatteryVoltage'), 'dataField': 'BatteryVoltage', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': DisplayVolts }
        ];

        mInventoryControls.DevicesContactHistoryListView = new sumo.controls.ListView('uDeviceContactListView', 'uDeviceContactHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView' }, lColumns);
        mInventoryControls.DevicesContactHistoryListView.bind('sort', uDeviceContactListView_OnSort);
    }
    //setLoadingBarStatus('uDeviceContactLoadingBar', 'uDeviceContactHolder', false, onToggle);
    $('#uDeviceContactLoadingBar').hide();
    $('#uDeviceContactHolder').show();
    mInventoryControls.DevicesContactHistoryListView.setDataSource(aContactList);
    // initial sort by contact date
    var InitialSort = {};
    InitialSort.Columns = [];
    InitialSort.Columns.push({
        ColumnName: "ContactDate",
        Direction: "Descending"
    });
    mInventoryControls.DevicesContactHistoryListView.sortExpression(InitialSort);

    if (typeof aParams !== 'undefined' && aParams !== null) {
        var lHolder = $('#uDeviceContactHolder');
        $('<div/>', { 'html': '[multiple selected]', 'class': 'MultipleSelected' }).appendTo(lHolder);
    }
}


// DATA POPULATION
function uInventoryDeviceCardView_Select() {
    "use strict";
    var i;
    for (i = 0; i < mInventoryData.DevicesSelectedIds.length; i++) {
        mInventoryControls.DevicesCardView.SelectRowById(mInventoryData.DevicesSelectedIds[i]);
    }
}

function setDeviceClusterDeleteButtonVisibility(aEnrolleeList) {
    "use strict";

    var lIsVisible = false,
        lBuilder,
        lList;

    lIsVisible = (isNullOrUndefined(aEnrolleeList) || aEnrolleeList.length === 0);

    if (!isNullOrUndefined(aEnrolleeList) && !lIsVisible) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lList = query(aEnrolleeList, lBuilder.RootExpression);
        lIsVisible = (lList.length === 0);
    }

    if (lIsVisible) {
        $('#uDeleteDeviceClusterButton').show();
    } else {
        $('#uDeleteDeviceClusterButton').hide();
    }
}

function uInventoryDeviceCardView_OnSelectChange(aSender, aKeyValue) {
    "use strict";
    uCancelDeviceButton_OnClick();
    if (!isNullOrUndefined(aKeyValue)) {
        mInventoryData.DevicesSelectedIds = []
        mInventoryData.DevicesSelectedIds.push(aKeyValue);
    } else {
        mInventoryData.DevicesSelectedIds = [];
    }
    CalculateSelectedDeviceOverlap();
    //mInventoryData.DevicesSelectedIds.push(aKeyValue);

    switch (mStateManager.Settings()[1]) {
        case 'Device':
            generateInventoryDeviceData();
            break;
        case 'AssignmentHistory':
            uAssignmentHistoryListView_Init();
            break;
        case 'ContactHistory':
            uDeviceContactListView_Init();
            break;
        case 'BatteryHistory':
            uDeviceBatteryChart_Init();
            break;
    }
    resetContentHoldersInventory();
}

//------------------
// Render Data Views
//------------------
function inventoryDeviceClustersDeviceTempList_Reset() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDeviceAssignmentList = [],
        lDeviceAssignments,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lDeviceAssignments = query(mInventoryData.DeviceClustersAssignedDeviceList, lBuilder.RootExpression);
    for (lKey in lDeviceAssignments) {
        if (lDeviceAssignments.hasOwnProperty(lKey)) {
            lItem = lDeviceAssignments[lKey];
            lItem = $.extend({}, lItem);
            lDeviceAssignmentList[lKey] = lItem;
        }
    }
    mInventoryData.DeviceClustersAssignedDeviceTempList = lDeviceAssignmentList;
}

function inventoryDeviceClustersEnrolleeTempList_Reset() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDeviceAssignmentList = [],
        lDeviceAssignments,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lDeviceAssignments = query(mInventoryData.DeviceClustersAssignedEnrolleeList, lBuilder.RootExpression);
    for (lKey in lDeviceAssignments) {
        if (lDeviceAssignments.hasOwnProperty(lKey)) {
            lItem = lDeviceAssignments[lKey];
            lItem = $.extend({}, lItem);
            lDeviceAssignmentList[lKey] = lItem;
        }
    }
    mInventoryData.DeviceClustersAssignedEnrolleeTempList = lDeviceAssignmentList;
}

function RenderDeviceClusterDeviceListView() {
    "use strict";
    var lList = {},
        lKey;

    inventoryDeviceClustersDeviceTempList_Reset();
    for (lKey in mInventoryData.DeviceClustersAssignedDeviceTempList) {
        if (mInventoryData.DeviceClustersAssignedDeviceTempList.hasOwnProperty(lKey)) {
            lList[lKey] = getDataItem(lKey, 'Devices');
        }
    }

    if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceListView)) {
        mInventoryControls.DeviceClusterDeviceListView.setDataSource(lList);
    }
}

function DeviceClusterDevice_OnLoad(aParams, aData) {
    "use strict";
    var lItem = null,
        lKey;
    mInventoryData.DeviceClustersAssignedDeviceList = [];
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            mInventoryData.DeviceClustersAssignedDeviceList[lItem.DeviceId] = lItem;
        }
    }
    RenderDeviceClusterDeviceListView();
    if (--mInventoryData.DeviceClusterReadsRemaining === 0) {
        setLoadingBarStatus('uDeviceClusterWaitingHolder', 'uDeviceClusterProfileHolder', false);
    }
}

function RenderDeviceClusterEnrolleeListView() {
    "use strict";
    var lKey,
        lList = {};
    inventoryDeviceClustersEnrolleeTempList_Reset();

    lList = getDeviceEnrolleesListData(mInventoryData.DeviceClustersAssignedEnrolleeTempList);

    if (!isNullOrUndefined(mInventoryControls.DeviceClusterEnrolleeListView)) {
        mInventoryControls.DeviceClusterEnrolleeListView.setDataSource(lList);
    }
}

function getDeviceEnrolleesListData(aEnrolleeList) {
    "use strict";
    var lEnrolleeList = aEnrolleeList;
    var lDeviceAssignmentList;
    var lDeviceClusterEnrolleeList = [];
    var lDeviceClusterEnrollee;
    var lDevice;
    var lKey;
    var lItem;

    for (lKey in lEnrolleeList) {
        if (lEnrolleeList.hasOwnProperty(lKey)) {
            lDeviceClusterEnrollee = $.extend({}, getDataItem(lEnrolleeList[lKey].EnrolleeId, 'Enrollees'));
            lDeviceAssignmentList = gCurrentDeviceAssignment[lDeviceClusterEnrollee.Id];
            for (lKey in lDeviceAssignmentList) {
                if (lDeviceAssignmentList.hasOwnProperty(lKey)) {
                    lItem = lDeviceAssignmentList[lKey];
                    lDevice = getDataItem(lItem.Id, 'Devices');
                    if ([2, 7].indexOf(lDevice.ProductType) !== -1) {
                        lDeviceClusterEnrollee.SerialNumber = lDevice.SerialNumber;
                    }
                }
            }
            lDeviceClusterEnrolleeList.push(lDeviceClusterEnrollee);
        }
    }

    return lDeviceClusterEnrolleeList;
}
function DeviceClusterEnrollee_OnLoad(aParams, aData) {
    "use strict";
    var lItem = null,
        lKey;
    mInventoryData.DeviceClustersAssignedEnrolleeList = [];
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            mInventoryData.DeviceClustersAssignedEnrolleeList[lItem.EnrolleeId] = lItem;
        }
    }
    if (--mInventoryData.DeviceClusterReadsRemaining === 0) {
        setLoadingBarStatus('uDeviceClusterWaitingHolder', 'uDeviceClusterProfileHolder', false);
    }
    RenderDeviceClusterEnrolleeListView();
    setDeviceClusterDeleteButtonVisibility(aData);
}

//----------------
// Data Population
//----------------

function CalculateSelectedDeviceOverlap() {
    "use strict";
    mInventoryData.DevicesSelectedOverlap['OrganizationCount'] = 0;
    mInventoryData.DevicesSelectedOverlap['ProductCount'] = 0;
    mInventoryData.DevicesSelectedOverlap['StatusCount'] = 0;
    mInventoryData.DevicesSelectedOverlap['ModeCount'] = 0;
    mInventoryData.DevicesSelectedOverlap['OrganizationId'] = -1;
    mInventoryData.DevicesSelectedOverlap['ProductId'] = -1;
    mInventoryData.DevicesSelectedOverlap['Status'] = -1;
    mInventoryData.DevicesSelectedOverlap['Mode'] = -1;
    mInventoryData.DevicesSelectedOverlap['IsAssigned'] = false;
    var i,
        lDevice;
    for (i = 0; i < mInventoryData.DevicesSelectedIds.length; i++) {
        lDevice = GetDevice(mInventoryData.DevicesSelectedIds[i]);

        if (lDevice.OrganizationId !== mInventoryData.DevicesSelectedOverlap['OrganizationId']) {
            mInventoryData.DevicesSelectedOverlap['OrganizationCount']++;
            mInventoryData.DevicesSelectedOverlap['OrganizationId'] = lDevice.OrganizationId;
        }
        if (lDevice.Status !== mInventoryData.DevicesSelectedOverlap['Status']) {
            mInventoryData.DevicesSelectedOverlap['StatusCount']++;
            mInventoryData.DevicesSelectedOverlap['Status'] = lDevice.Status;
        }
        // if status is active
        if (!mInventoryData.DevicesSelectedOverlap['IsAssigned'] && lDevice.Status === 4) {
            mInventoryData.DevicesSelectedOverlap['IsAssigned'] = true;
        }
        if (lDevice.Mode !== mInventoryData.DevicesSelectedOverlap['Mode']) {
            mInventoryData.DevicesSelectedOverlap['ModeCount']++;
            mInventoryData.DevicesSelectedOverlap['Mode'] = lDevice.Mode;
        }
        if (lDevice.ProductId !== mInventoryData.DevicesSelectedOverlap['ProductId']) {
            mInventoryData.DevicesSelectedOverlap['ProductCount']++;
            mInventoryData.DevicesSelectedOverlap['ProductId'] = lDevice.ProductId;
        }
    }
    if (mInventoryData.DevicesSelectedOverlap['OrganizationCount'] > 1) {
        mInventoryData.DevicesSelectedOverlap['OrganizationId'] = -1;
    }
    if (mInventoryData.DevicesSelectedOverlap['ProductCount'] > 1) {
        mInventoryData.DevicesSelectedOverlap['ProductId'] = -1;
    }
    if (mInventoryData.DevicesSelectedOverlap['StatusCount'] > 1) {
        mInventoryData.DevicesSelectedOverlap['Status'] = -1;
    }
    if (mInventoryData.DevicesSelectedOverlap['ModeCount'] > 1) {
        mInventoryData.DevicesSelectedOverlap['Mode'] = -1;
    }
}
const DEVICE_STATUS = {
    ASSIGNED: 4,
};
function PopulateDeviceStatusDropdown(aId, aBaseElementId, aIsMultiple) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lBaseElement = $('#' + aBaseElementId),
        lSelect = $('<select/>', {
            'id': aId
        }),
        lStatuses = getDataItems('DeviceStatuses'),
        lValidOptions = [],
        lOption,
        lKey;
    const INVENTORY_UNRECOVERABLE_STATUS = 101;
    var lPermissionInvUnrecStatus = CheckUserHasPermission(INVENTORY_UNRECOVERABLE_STATUS);
    var lDeviceNewStatuses = [];

    if (!lPermissionInvUnrecStatus) {
        lBuilder.AddNewExpressionConditional('Id', 8, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lStatuses = query(lStatuses, lBuilder.RootExpression);
        lBuilder.Clear();
    }

    if (typeof aIsMultiple !== 'undefined' && aIsMultiple) {
        lOption = $('<option/>', {
            'text': '[multiple selected]',
            'value': '-1'
        });
        lOption.appendTo(lSelect);
    }

    switch (mInventoryData.DevicesSelectedOverlap.Status) {
        case 1:
            lValidOptions = [1, 5];
            break;
        case 2:
            lValidOptions = [2, 5];
            break;
        case 5:
            lValidOptions = [5, 7, 8];
            break;
    }

    lBuilder.AddNewExpressionConditional('Id', [DEVICE_STATUS.ASSIGNED], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lStatuses = query(lStatuses, lBuilder.RootExpression);

    for (lKey in lStatuses) {
        if (lStatuses.hasOwnProperty(lKey)) {
            var lStatus = lStatuses[lKey];
            lOption = $('<option/>', {
                'text': localizeDataItem('DeviceStatus', lStatus.Name),
                'value': lStatus.Id
            });
            lOption.appendTo(lSelect);
        }
    }
    lBaseElement.html('');
    lSelect.appendTo(lBaseElement);
}

function PopulateDeviceModeDropdown(aId, aBaseElementId, aIsMultiple) {
    "use strict";
    var lBaseElement = $('#' + aBaseElementId),
        lSelect = $('<select/>', {
            'id': aId
        }),
        lModes = getDataItems('DeviceModes'),
    lOption;
    if (typeof aIsMultiple !== 'undefined' && aIsMultiple) {
        lOption = $('<option/>', {
            'text': '[multiple selected]',
            'value': '-1'
        });
        lOption.appendTo(lSelect);
    }
    for (var lKey in lModes) {
        if (lModes.hasOwnProperty(lKey)) {
            var lMode = lModes[lKey];
            lOption = $('<option/>', {
                'text': localizeDataItem('DeviceMode', lMode.Name),
                'value': lMode.Id
            });
            $(lOption).appendTo(lSelect);
        }
    }
    lBaseElement.html('');
    lSelect.appendTo(lBaseElement);
}

function SelectFirstDeviceItem(aCardView, aCallback) {
    "use strict";
    aCardView.selectedIndex(0);
    if (aCallback !== null) {
        aCallback();
    }
}

function populateInventoryDeviceData(aDeviceDetail, aContactDetail, aContactList) {
    "use strict";
    var i,
        lCount = aContactList.length,
        lCounter = 0,
        lPointList = [],
        lLabelList = [],
        lContactFormatters = {},
        lDevice,
        lContact,
        lAssignment,
        lEnrollee,
        lEnrollees = [],
        lBuilder = new SumoPredicateBuilder(),
        lAssignmentList = getDataItems('CurrentDeviceAssignments'),
        lAssignmentQuery,
        lIsAssigned = false,
        lAssignedEnrolleeHtml = [],
        lItem,
        lKey;
    $('.InventoryDevicesEmptyListUnavailable').show();   

    if (lCount === 1) {
        if (aDeviceDetail.ProductId !== 104) {
            lContactFormatters = {
                'ContactDate': DisplayLongDateTime,
                'TrackDate': DisplayLongDateTime,
                'Status': contactStatusImageFormatter,
                'PercentGps': DisplayPercent,
                'BatteryLevel': inventoryBatteryLevelFormatter,
                'BatteryVoltage': DisplayVolts,
                'Longitude': DisplayLongitude,
                'Speed': DisplaySpeed,
                'Direction': DeviceDirectionFormatter
            };
        } else {
            lContactFormatters = {
                'ContactDate': DisplayLongDateTime,
                //'TrackDate': DisplayLongDateTime,
                'Status': contactStatusImageFormatter,
                'PercentGps': DisplayPercent,
                'BatteryLevel': inventoryBatteryLevelFormatter,
                'BatteryVoltage': DisplayVolts,
                'Longitude': DisplayLongitude,
                'Speed': DisplaySpeed,
                'Direction': DeviceDirectionFormatter
            };
        }
    }

    //$('#uEditDeviceButton').show();
    if (aDeviceDetail.ProductId === 103 || aDeviceDetail.ProductId === 151) {
        $('#uDeviceModeRow').show();
        $(".PhoneNumber").hide();
        $('#uAgentFingerprintSetupButton').hide();
    } else if (aDeviceDetail.ProductId === 109 && aDeviceDetail.SupportFingerprintFlag) {
        $(".PhoneNumber").show();
        $('#uAgentFingerprintSetupButton').show();
    } else {
        $('#uDeviceModeRow').hide();
        $(".PhoneNumber").hide();
        $('#uAgentFingerprintSetupButton').hide();
    }
    
    if (aDeviceDetail.Status === 4) {
        //$('.DeviceAssignment').show();
        lBuilder.AddNewExpressionConditional('Id', aDeviceDetail.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAssignmentQuery = query(lAssignmentList, lBuilder.RootExpression);

        for (lKey in lAssignmentQuery) {
            if (lAssignmentQuery.hasOwnProperty(lKey)) {
                lItem = lAssignmentQuery[lKey];
                lEnrollee = getDataItem(lItem.EnrolleeId, 'Enrollees');
                if (!isNullOrUndefined(lEnrollee)) {
                    lEnrollees.push(lEnrollee);
                    aDeviceDetail.EnrolleeName = lEnrollee.FullName;
                    lAssignedEnrolleeHtml.push('<div>');
                    lAssignedEnrolleeHtml.push(lEnrollee.FullName);
                    lAssignedEnrolleeHtml.push(' (');
                    lAssignedEnrolleeHtml.push(AgentNameFormatter(lEnrollee.AgentId));
                    lAssignedEnrolleeHtml.push(')');
                    lAssignedEnrolleeHtml.push('</div>');
                    if (!lIsAssigned) {
                        lIsAssigned = true;
                    }
                }
            }
        }

        if (lIsAssigned) {
            $('.DeviceAssignment').show();
            $('#uDeviceDetailEnrolleeName').html(lAssignedEnrolleeHtml.join(''));
            //$('#uDeviceDetailAgentName').html(AgentNameFormatter(lEnrollee.AgentId));
        } else {
            $('.DeviceAssignment').hide();
        }

    } else {
        $('.DeviceAssignment').hide();
    }
    var lDeviceDetailFormatters = {
        'OrganizationId': multiSelectOrganizationNameFormatter,
        'Status': multiSelectDeviceStatusNameFormatter,
        'BluboxGroup': DeviceClusterNameFormmater,
        'Mode': multiSelectDeviceModeNameFormatter
    };
    if(aDeviceDetail.ProductId == 121){
        // Display Days In Schema and Total of tests
        lDeviceDetailFormatters['DaysInSchema'] = soberTrackDaysInUseFormatter;
        lDeviceDetailFormatters['STTotalTests'] = soberTrackTotalOfTestsFormatter;
        $('#uInventoryDaysInSchema').show();
        $('#uInventorySTTotalTests').show();
    }else{
        $('#uInventoryDaysInSchema').hide();
        $('#uInventorySTTotalTests').hide();
    }
    PopulateDetailView(aDeviceDetail,lDeviceDetailFormatters, 'uDeviceDetail');
    if (!isNullOrUndefined(aContactDetail) && aDeviceDetail.ProductId !== 105 && aDeviceDetail.ProductId != 106 && aDeviceDetail.ProductId !== 107) {
        if (aContactDetail.Type !== 'NoContacts') {
            if (!isNullOrUndefined(mInventoryControls.Map)) {
                if (aContactDetail.Latitude !== 0 && aContactDetail.Latitude !== 0) {
                    mInventoryControls.Map.show();
                    $('#uMapPanel').show();
                    $('#uDistanceToolHolder').show();
                } else {
                    mInventoryControls.Map.hide();
                    $('#uMapPanel').hide();
                    $('#uDistanceToolHolder').hide();
                    $('#uDeviceTrackSearchEditHolder').hide();
                }
            }
            $(window).resize();
        } else {
            if (!isNullOrUndefined(mInventoryControls.Map)) {
                mInventoryControls.Map.hide();
                $('#uMapPanel').hide();
                $('#uDistanceToolHolder').hide();
                $('#uDeviceTrackSearchEditHolder').hide();
            }
        }
        if (aContactDetail.BatteryLevel <= 0) {
            $('#uLastContactBatteryLevel').hide();
        } else {
            $('#uLastContactBatteryLevel').show();
        }
        PopulateDetailView(aContactDetail, lContactFormatters, 'uLastContact');
        $('.LastContact').show();
        for (var i = 0; i < lCount; i++) {
            lContact = aContactList[i];
            if (!isNullOrUndefined(lContact)) {
                lDevice = GetDevice(lContact.DeviceId);
                if (!isNullOrUndefined(lDevice)) {
                    lPointList.push({
                        'data': lContact,
                        'latitude': lContact.Latitude,
                        'longitude': lContact.Longitude,
                        'anchor': { 'x': 11, 'y': 11 },
                        'iconUri': 'Images/Maps/Trackpoints/11100101.png',
                        'hoverText': DisplayShortDateTime(lContact.TrackDate) + '\n' + (lCounter++).toString() + ' of ' + lCount.toString()
                    });
                    lLabelList.push({
                        'data': lContact,
                        'latitude': lContact.Latitude,
                        'longitude': lContact.Longitude,
                        'text': lDevice.SerialNumber,
                        'horizontalOffset': -15,
                        'verticalOffset': -15,
                        'cssClass': 'NumericLabel'
                    });
                }
            }
        }
    } else {
        $('.LastContact').hide();
        if (!isNullOrUndefined(mInventoryControls.Map)) {
            mInventoryControls.Map.hide();
            $('#uMapPanel').hide();
            $('#uDistanceToolHolder').hide();
            $('.TrackSearch').hide();
        }
    }
    if (!isNullOrUndefined(mInventoryControls.Map)) {
        mInventoryControls.Map.layerSetDataSource('trackpoints', lPointList);
        mInventoryControls.Map.layerSetDataSource('NumberedLabels', lLabelList);
        mInventoryControls.Map.fitBounds();
        if (!isNullOrUndefined(lDevice) && !isNullOrUndefined(aContactDetail) && aContactDetail.Latitude !== 0 && aContactDetail.Latitude !== 0) {
            $('.TrackSearch').show();
            populateDeviceLastContactTrackSearchDropdown('uDeviceTrackRange', 'uDeviceTrackSearchEditHolder', lEnrollees, aContactDetail, lDevice);
        } else {
            $('.TrackSearch').hide();
        }
    }
}

function populateDeviceLastContactTrackSearchDropdown(aId, aBaseElementId, aEnrollee, aContactDetail, aDevice) {
    "use strict";
    var lBaseElement = $('#' + aBaseElementId),
        lSelect = $('<select/>', {
            'id': aId
        }),
        lRanges = [{ 'Name': '15 Minutes', 'Value': 15 }, { 'Name': '30 Minutes', 'Value': 30 }, { 'Name': '60 Minutes', 'Value': 60 }],
        lOption;

    lOption = $('<option/>', {
        'text': 'Last Call',
        'value': '0'
    });
    lOption.appendTo(lSelect);

    for (var lKey in lRanges) {
        if (lRanges.hasOwnProperty(lKey)) {
            var lRange = lRanges[lKey];
            lOption = $('<option/>', {
                'text': lRange.Name,
                'value': lRange.Value
            });
            $(lOption).appendTo(lSelect);
        }
    }
    lBaseElement.html('');
    lSelect.appendTo(lBaseElement);
    lBaseElement.show();
    $('#' + aId).change(function () { searchDeviceDetailTrackRange(aEnrollee, aContactDetail, aDevice, $(this).val()); });
}

function searchDeviceDetailTrackRange(aEnrollee, aContactDetail, aDevice, aValue) {
    "use strict";
    var lEndDate = new Date(),
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lStart = new Date();

    mActivityNotification.addNotification(localizeText('cEnrolleeLoading') + '..........');

    lSort.addDescendingColumn('EndDate');
    lBuilder.AddNewExpressionConditional('SerialNumber', aDevice.SerialNumber, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, uAssignmentRange_OnSuccess, Sad, { 'Contact': aContactDetail, 'Device': aDevice, 'Value': aValue }, lSort, 1);
}

function uAssignmentRange_OnSuccess(aParams, aData) {
    "use strict";

    var lEndDate = new Date(aParams.Contact.TrackDate),
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee,
        lStart = new Date(lEndDate - (60 * aParams.Value * 1000));

    if (!isNullOrUndefined(aData) && count(aData) > 0) {
        for (var i = 0; i < aData.length; i++) {
            lEnrollee = getDataItem(aData[i].EnrolleeId, "Enrollees");
            if (!isNullOrUndefined(lEnrollee)) {
                lEndDate = displayEventInEnrolleeTimeZone(moment(aParams.Contact.TrackDate)._d, lEnrollee);
                lStart = FixSentDate(moment(lEndDate).add(-(aParams.Value), 'minutes')._d, lEnrollee);
                lEndDate = FixSentDate(moment(lEndDate)._d, lEnrollee);
                break;
            }
        }
    }//end of if

    if (lEnrollee) {
        var lHistoryTrackStartDate = veritracks.system.clientSetting('HistoryTrackStartDate');
        var lIsHistoricalDate = false;
        if (!isNullOrUndefined(lHistoryTrackStartDate)) {
            if (lStart < lHistoryTrackStartDate) {
                lIsHistoricalDate = true;
            }
        }
        veritracks.mapping.readTrackpointsProc(lEnrollee.Id, lIsHistoricalDate, lStart, lEndDate, false, uDeviceDetailTrackRange_OnSuccess, Sad, { 'Contact': aParams.Contact, 'Device': aParams.Device })
    } else {
        lBuilder.AddNewExpressionConditional('DeviceId', aParams.Device.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('TrackDate', lStart.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('TrackDate', lEndDate.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.TrackpointHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, uDeviceDetailTrackRange_OnSuccess, Sad, { 'Contact': aParams.Contact, 'Device': aParams.Device }, null, 0);
    }

}

function uDeviceDetailTrackRange_OnSuccess(aParams, aData) {
    "use strict";
    var lTrackList = [];
    var lLabelList = [];
    var lSort = new SortExpression();

    //FixDates(aData);
    //lSort.addDescendingColumn('TrackDate');

    //aData = lSort.sort(aData);

    lTrackList.push({
        'data': aParams.Contact,
        'latitude': aParams.Contact.Latitude,
        'longitude': aParams.Contact.Longitude,
        'anchor': { 'x': 11, 'y': 11 },
        'iconUri': 'Images/Maps/Trackpoints/11100101.png',
        'hoverText': ''
    });

    for (var key in aData) {
        if (aData.hasOwnProperty(key)) {

            lTrackList.push({
                'data': aData[key],
                'latitude': aData[key].Latitude,
                'longitude': aData[key].Longitude,
                'anchor': { 'x': 11, 'y': 11 },
                'iconUri': 'Images/Maps/TrackPoint.png'
            });
        }
    }

    mInventoryControls.Map.layerSetDataSource('trackpoints', lTrackList);
    mInventoryControls.Map.fitBounds();

    if (isNullOrUndefined(aData) || count(aData) == 0) {
        mActivityNotification.addNotification(localizeWrapper('cInventoryTrackSearchFailed') + aParams.Device.SerialNumber);
    }
}

function generateInventoryDeviceData() {
    "use strict";
    //alert('generate contact list');
    var lDeviceDetail = {},
        lContactList = [],
        lContactDetail = {},
        lKey,
        lDeviceClusterDevices = getDataItems('DeviceClusterDevices'),
        lBuilder = new SumoPredicateBuilder(),
        lContact;
    if (mInventoryData.DevicesSelectedIds.length === 0) {
        //SelectFirstDeviceItem(generateInventoryDeviceData);
        SelectFirstDeviceItem(mInventoryControls.DevicesCardView, null);
    } else if (mInventoryData.DevicesSelectedIds.length === 1) {
        lDeviceDetail = GetDevice(mInventoryData.DevicesSelectedIds[0]);
        lContactDetail = getDeviceLastContact(lDeviceDetail.Id);
        lContactList.push(lContactDetail);
        lBuilder.AddNewExpressionConditional("DeviceId", mInventoryData.DevicesSelectedIds[0], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var deviceGroup = query(lDeviceClusterDevices, lBuilder.RootExpression);
        if (!isNullOrUndefined(deviceGroup) && deviceGroup.length > 1) {
            lDeviceDetail['BluboxGroup'] = deviceGroup.pop();
            $("#uInventoryBluBoxGroup").show();
        } else {
            $("#uInventoryBluBoxGroup").hide();
        }
        populateInventoryDeviceData(lDeviceDetail, lContactDetail, lContactList);
    } else {
        lDeviceDetail.IsAssigned = false;
        lDeviceDetail['OrganizationId'] = mInventoryData.DevicesSelectedOverlap['OrganizationId'];
        lDeviceDetail['ProductId'] = mInventoryData.DevicesSelectedOverlap['ProductId'];
        lDeviceDetail['Status'] = mInventoryData.DevicesSelectedOverlap['Status'];
        lDeviceDetail['Mode'] = mInventoryData.DevicesSelectedOverlap['Mode'];

        lContactDetail.Type = 'NoContacts';
        for (lKey in mInventoryData.DevicesSelectedIds) {
            if (mInventoryData.DevicesSelectedIds.hasOwnProperty(lKey)) {
                lContact = getDeviceLastContact(mInventoryData.DevicesSelectedIds[lKey]);
                if (!isNullOrUndefined(lContact)) {
                    lContactList.push(lContact);
                    lContactDetail.Type = 'Contacts';
                }
            }
        }

        lContactDetail['ContactDate'] = '[multiple selected]';
        lContactDetail['TrackDate'] = '[multiple selected]';
        lContactDetail['Status'] = '[multiple selected]';
        lContactDetail['RecordCount'] = '[multiple selected]';
        lContactDetail['GpsRecordCount'] = '[multiple selected]';
        lContactDetail['PercentGps'] = '[multiple selected]';
        lContactDetail['BatteryLevel'] = -1;
        lContactDetail['BatteryVoltage'] = '[multiple selected]';
        lContactDetail['Latitude'] = '[multiple selected]';
        lContactDetail['Longitude'] = '';
        lContactDetail['Speed'] = '[multiple selected]';
        lContactDetail['Direction'] = '[multiple selected]';
        lContactDetail['DeviceVersion'] = '[multiple selected]';

        populateInventoryDeviceData(lDeviceDetail, lContactDetail, lContactList);
    }
}

function uDeviceDetailMap_Init() {
    "use strict";
    var lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        lLayerOptions;

    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }

    mInventoryControls.Map = new sumo.maps.GoogleMapControl('uDeviceDetailMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': inventoryCalculateDistance_OnClick });
    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    };
    mInventoryControls.Map.layerAdd('trackpoints', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    };
    mInventoryControls.Map.layerAdd('address', lLayerOptions);

    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 800000
    };
    mInventoryControls.Map.layerAdd('NumberedLabels', lLayerOptions);


    mInventoryControls.Map.layerAdd('DistancePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });

    mInventoryControls.Map.layerAdd('DistanceLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mInventoryControls.Map.layerAdd('ConnectedDistancePoints', {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });

    // zones support
    mInventoryControls.Map.layerAdd('Zones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': null
    });

    // zones support
    mInventoryControls.Map.layerAdd('KnownZones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': zonesKnownLocationMapShape_OnChange
    });

    mInventoryControls.Map.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1700000
    });

    mInventoryControls.Map.layerAdd('ZonesNames', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });
    $(window).resize();
}

function uAssignmentHistoryListView_Init() {
    "use strict";
    if (mInventoryData.DevicesSelectedIds.length === 0) {
        if (!isNullOrUndefined(mInventoryControls.DevicesCardView)) {
            SelectFirstDeviceItem(mInventoryControls.DevicesCardView, null);
        }
        //uAssignmentHistoryListView_OnLoad({}, []);
    } else if (mInventoryData.DevicesSelectedIds.length === 1) {
        var lSort = new SortExpression();
        var lDevice = getDataItem(mInventoryData.DevicesSelectedIds[0], 'Devices');
        lSort.addDescendingColumn('StartDate');

        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', lDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        if (!isNullOrUndefined(mInventoryControls.DevicesAssignmentListView)) {
            mInventoryControls.DevicesAssignmentListView.setDataSource([]);
        }

        ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, uAssignmentHistoryListView_OnLoad, Sad, null, lSort, 0);
    } else {
        uAssignmentHistoryListView_OnLoad({}, []);
    }
}

function uDeviceContactListView_Init() {
    "use strict";

    function onToggle() {
        lBuilder.AddNewExpressionConditional('DeviceId', mInventoryData.DevicesSelectedIds[0], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ContactDate', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        GetDeviceContact(mInventoryData.DevicesSelectedIds[0], lStartDate.toWcf(), uDeviceContactListView_OnLoad, Sad, null, $('#uDeviceContactHistoryDataAmount').val());
        //ReadMultiple(gObjectList.DeviceContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, uDeviceContactListView_OnLoad, Sad, null, lSort, 0);
        $(window).resize();
    }

    if (mInventoryData.DevicesSelectedIds.length === 0) {
        //SelectFirstDeviceItem(mInventoryControls.DevicesCardView, uDeviceContactListView_Init);
        mInventoryControls.DevicesCardView.selectedIndex(0);
    } else if (mInventoryData.DevicesSelectedIds.length === 1) {
        var lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression(),
            lStartDate = new Date();
        lSort.addDescendingColumn('ContactDate');
        lStartDate.addDays(-1);


        if (!isNullOrUndefined(mInventoryControls.DevicesContactHistoryListView)) {
            mInventoryControls.DevicesContactHistoryListView.setDataSource([]);
        }
        setLoadingBarStatus('uDeviceContactLoadingBar', 'uDeviceContactHolder', true, onToggle);
    } else {
        uDeviceContactListView_OnLoad({}, []);
    }
}

function populateDeviceClusterData() {
    "use strict";
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    function onToggle() {
        var lBuilder = new SumoPredicateBuilder();
        mInventoryData.DeviceClusterReadsRemaining += 2;
        lBuilder.AddNewExpressionConditional('DeviceClusterId', mInventoryData.DeviceClustersSelected, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, true, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceClusterDevice.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceClusterDevice_OnLoad, null, null);
        ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceClusterEnrollee_OnLoad, null, null);
        PopulateDetailView(lDeviceCluster, { 'OrganizationId': OrganizationNameFormatter, 'ZoneId': ZoneNameFormatter }, 'uDeviceCluster');
        // details view zone name needs to show if zone association
        if (lDeviceCluster.ZoneId < 0) {
            $('#uAssociatedZone').hide();
        } else {
            $('#uAssociatedZone').show();
        }
    }

    if (lDeviceCluster !== null) {
        setLoadingBarStatus('uDeviceClusterWaitingHolder', 'uDeviceClusterProfileHolder', true, onToggle);
    }
}

function populateDeviceClusterZoneData() {
    "use strict";
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    if (lDeviceCluster)
        populateDeviceClusterZone(lDeviceCluster.ZoneId);
}

function populateDeviceClusterZone(aZoneId) {
    "use strict";
    var lZone;
    if (aZoneId > 0) {
        lZone = getDataItem(aZoneId, 'Zones');
        mInventoryControls.Map.show();
        $('#uMapPanel').show();
        $(window).resize();
        veritracks.mapping.renderZones(mInventoryControls.Map, 'Zones', [lZone], populateDeviceClusterZoneData_onComplete, lZone);
    } else {
        mInventoryControls.Map.hide();
        $('#uMapPanel').hide();
    }
}

function populateDeviceClusterZoneData_onComplete(aParams, aZones, aVertices) {
    "use strict";
    var lZone = aZones[0];
    mInventoryControls.Map.layerSetDataSource('Zones', aZones);
    mInventoryControls.Map.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(aZones));
    mInventoryControls.Map.fitBounds();
}

function PopulateDeviceClusterEditData() {
    "use strict";
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    if (isNullOrUndefined(lDeviceCluster)) {
        lDeviceCluster = new DeviceCluster();
        mInventoryData.DeviceClusterReadsRemaining += 2;
        DeviceClusterDevice_OnLoad(null, []);
        DeviceClusterEnrollee_OnLoad(null, []);
    }

    $('#uAssociatedZone').show(); // always enable until decided that client property needed
    //Vulnerability 3251
    lDeviceCluster.Description = veritracks.system.decodeHtml(lDeviceCluster.Description);
    lDeviceCluster.Name = veritracks.system.decodeHtml(lDeviceCluster.Name);
    populateEditView(lDeviceCluster, [{ 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': getDataItems('Organizations'), 'DataValueField': 'Id', 'DataTextField': 'Name' }
    ], {}, 'uDeviceCluster', 'Edit');
    $('#uDeviceClusterOrganizationIdEdit').change();
}


//------------
// Page Events
//------------


function deviceClustersDeleteButtonCheck() {
    "use strict";
    var lSelected = mInventoryControls.CardView.selectedDataItem();
    if (!isNullOrUndefined(lSelected) && (lSelected.EnrolleeCount > 0 || lSelected.DeviceCount > 0)) {
        $('#uDeleteDeviceClusterButton').hide();
    } else {
        $('#uDeleteDeviceClusterButton').show();
    }
}

function uDeviceClusterCardView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceListView)) {
        mInventoryControls.DeviceClusterDeviceListView.setDataSource([]);
        mInventoryControls.DeviceClusterEnrolleeListView.setDataSource([]);
    }
    if (aId !== -1) {
        $('#uDeleteDeviceClusterButton').hide();
        mInventoryData.DeviceClustersSelected = aId;
        uCancelDeviceClusterButton_OnClick();
        populateDeviceClusterData();
        deviceClustersDeleteButtonCheck();
        if (mInventoryControls.Map)
            populateDeviceClusterZoneData();
    }
}

function SingleDeviceWrite_OnSuccess(aParams, aItem) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cInventorySavedDeviced') + aItem.SerialNumber);
    setDataItem(aItem.Id, 'Devices', aItem);
    mInventoryControls.DeviceCardViewFilter.filter();
}

function MultipleDeviceWrite_OnSuccess(aParams, aList) {
    "use strict";
    var lKey;
    for (lKey in aList) {
        if (aList.hasOwnProperty(lKey)) {
            var lItem = aList[lKey];
            mActivityNotification.addNotification(localizeWrapper('cInventorySavedDeviced') + lItem.SerialNumber);
            setDataItem(lItem.Id, 'Devices', lItem);
        }
    }
    mInventoryControls.DeviceCardViewFilter.filter();
}

function uEditDeviceButton_OnClick() {
    "use strict";
    var lDeviceDetail = {};
    $('#uEditDeviceButton').hide();
    $('#uSaveDeviceButton').show();
    $('#uCancelDeviceButton').show();
    $('#uAgentFingerprintSetupButton').hide();
    //$('#uInventoryStatus').hide();

    if ([1, 2, 5].indexOf(mInventoryData.DevicesSelectedOverlap.Status) !== -1) {
        $('#uInventoryStatus').show();
    } else {
        $('#uInventoryStatus').hide();
    }

    if (mInventoryData.DevicesSelectedIds.length === 1) {
        PopulateOrganizationDropdown('uDeviceDetailOrganizationIdEdit', 'uDeviceDetailOrganizationIdEditHolder', false);
        PopulateDeviceStatusDropdown('uDeviceDetailStatusEdit', 'uDeviceDetailStatusEditHolder', false);
        PopulateDeviceModeDropdown('uDeviceDetailModeEdit', 'uDeviceDetailModeEditHolder', false);
        lDeviceDetail = getDataItem(mInventoryData.DevicesSelectedIds[0], 'Devices');
    } else {
        PopulateOrganizationDropdown('uDeviceDetailOrganizationIdEdit', 'uDeviceDetailOrganizationIdEditHolder', mInventoryData.DevicesSelectedOverlap['OrganizationCount'] !== 1);
        PopulateDeviceStatusDropdown('uDeviceDetailStatusEdit', 'uDeviceDetailStatusEditHolder', mInventoryData.DevicesSelectedOverlap['StatusCount'] !== 1);
        PopulateDeviceModeDropdown('uDeviceDetailModeEdit', 'uDeviceDetailModeEditHolder', mInventoryData.DevicesSelectedOverlap['ModeCount'] !== 1);
        lDeviceDetail = mInventoryData.DevicesSelectedOverlap;
    }

    populateEditView(lDeviceDetail, [], {}, 'uDeviceDetail', 'Edit');
    if ((mInventoryData.DevicesSelectedIds.length === 1 && lDeviceDetail.Status === 4) || (mInventoryData.DevicesSelectedIds.length !== 1 && lDeviceDetail['IsActive'])) {
        $('#uInventoryDevicePanel .EditableMultiple').hide();
        $('#uInventoryDevicePanel .EditingMultiple').show();
    } else {
        $('#uInventoryDevicePanel .EditableMultiple').show();
        $('#uInventoryDevicePanel .EditingMultiple').hide();
        EnterEditMode('uInventoryDevicePanel');
    }
    resetContentHoldersInventory();
}



function uSaveDeviceButton_OnClick() {
    "use strict";
    $('#uInventoryStatus').show();
    $('#uEditDeviceButton').show();
    $('#uSaveDeviceButton').hide();
    $('#uCancelDeviceButton').hide();
    $('#uInventoryDevicePanel .EditingMultiple').hide();

    var lDeviceDetail = { 'OrganizationId': -1, 'Status': -1, 'Mode': -1 },
        lDevice = GetDevice(mInventoryData.DevicesSelectedIds[0]),
        lUpdatedDevices = [],
        i,
        lIsAssigned = ((mInventoryData.DevicesSelectedIds.length === 1 && lDevice.Status === 4) || (mInventoryData.DevicesSelectedIds.length > 1 && mInventoryData.DevicesSelectedOverlap['IsAssigned']));

    populateFromEditView(lDeviceDetail, 'uDeviceDetail', 'Edit');

    for (i = 0; i < mInventoryData.DevicesSelectedIds.length; i++) {
        lDevice = GetDevice(mInventoryData.DevicesSelectedIds[i]);
        if (!lIsAssigned) {
            if (!isNullOrUndefined(lDeviceDetail.OrganizationId) && lDeviceDetail.OrganizationId >= 0) {
                lDevice.OrganizationId = lDeviceDetail.OrganizationId;
            }
            if (!isNullOrUndefined(lDeviceDetail.Status) && lDeviceDetail.Status >= 0) {
                lDevice.Status = lDeviceDetail.Status;
            }
        }
        if (lDevice.ProductId === 103 || lDevice.ProductId === 151) {
            if (!isNullOrUndefined(lDeviceDetail.Mode) && lDeviceDetail.Mode >= 0) {
                lDevice.Mode = lDeviceDetail.Mode;
            }
        }
        lDevice.TransactionId = moment().format("YYYYMMDDHHmmss");
        lDevice.UserId = gUserDetails.UserId;
        lUpdatedDevices.push(lDevice);
    }
    if (lUpdatedDevices.length === 1) {
        WriteSingle(lDevice, SingleDeviceWrite_OnSuccess, Sad, null);
    } else {
        WriteMultiple(lUpdatedDevices, MultipleDeviceWrite_OnSuccess, Sad, null);
    }
    CalculateSelectedDeviceOverlap();
    generateInventoryDeviceData();
    ExitEditMode('uInventoryDevicePanel');

    if (lDeviceDetail.ProductId === 109 && aDeviceDetail.SupportFingerprintFlag) {
        $('#uAgentFingerprintSetupButton').show();
    }

    resetContentHoldersInventory();
}

function uCancelDeviceButton_OnClick() {
	"use strict";
	$('#uInventoryStatus').show();
    $('#uEditDeviceButton').show();
    $('#uSaveDeviceButton').hide();
    $('#uCancelDeviceButton').hide();
    $('#uInventoryDevicePanel .EditingMultiple').hide();

	if (mInventoryData.DevicesSelectedOverlap['IsAssigned']) {
        $('#uInventoryDevicePanel .EditableMultiple').show();
		$('#uInventoryDevicePanel .EditingMultiple').hide();

		$('#uEditDeviceButton').show();
	} else {

		ExitEditMode('uInventoryDevicePanel');
    }
    
    ExitEditMode('uInventoryDevicePanel');

    if (mInventoryData.DevicesSelectedIds.length > 0) {
        var lDeviceDetail = getDataItem(mInventoryData.DevicesSelectedIds[0], 'Devices');
        if (lDeviceDetail.ProductId === 109 && lDeviceDetail.SupportFingerprintFlag) {
            $('#uAgentFingerprintSetupButton').show();
        }
    }
     
	resetContentHoldersInventory();
}

function uAgentFingerprintSetupButton_OnClick() {
    "use strict";
    displayDeviceActionPopup(176, mInventoryData.DevicesSelectedIds[0]);
}

function uEditDeviceListButton_OnClick() {
    "use strict";
    var lKey,
        lColumns = null,
        lListItems = [],
        lAssignment,
        lAssignedDevices = [],
        lAssignedIds = [],
        lPredicateBuilder = new SumoPredicateBuilder(),
        lOrganizationId,
        lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cOk'), '', 'uEditDeviceListOkButton_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), '', 'uEditDeviceListCancelButton_OnClick()')).appendTo(lButtonCommandBar);

    lPredicateBuilder.AddNewExpressionConditional('Status', [1, 2, 3, 5], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('ProductId', 105, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lOrganizationId = $('#uDeviceClusterOrganizationIdEdit').val();
    if (lOrganizationId !== '') {
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And())
    }

    lListItems = query(getDataItems('Devices'), lPredicateBuilder.RootExpression);
    lPredicateBuilder.Clear();

    //       lOrganizationId = $('#uDeviceClusterOrganizationIdEdit').val();


    lPredicateBuilder.AddNewExpressionConditional('DeviceClusterId', mInventoryData.DeviceClustersSelected, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lAssignedDevices = query(mInventoryData.DeviceClustersAssignedDeviceTempList, lPredicateBuilder.RootExpression);

    for (lKey in lAssignedDevices) {
        if (lAssignedDevices.hasOwnProperty(lKey)) {
            lAssignment = lAssignedDevices[lKey];
            lListItems[lAssignment.DeviceId] = GetDevice(lAssignment.DeviceId);
            if (lAssignment.IsActive) {
                lAssignedIds.push(lAssignment.DeviceId);
            }
        }
    }

    DisplayPopup(localizeWrapper('cInventoryEditDevices'), '', lButtonCommandBar, true);

    lColumns = [
        { 'id': 'Selected', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': 'SelectionColumn', 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'SerialNumber', 'title': localizeWrapper('cSerialNumber'), 'dataField': 'SerialNumber', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null, 'canResize': false },
        { 'id': 'ProductId', 'title': localizeWrapper('cEnrolleeProduct'), 'dataField': 'ProductId', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': ProductNameFormatter, 'canResize': false }
    ];

    if (!isNullOrUndefined(mInventoryControls.DeviceClusterDeviceEditListView)) {
        mInventoryControls.DeviceClusterDeviceEditListView.dispose();
        mInventoryControls.DeviceClusterDeviceEditListView = null;
    }
    mInventoryControls.DeviceClusterDeviceEditListView = new sumo.controls.ListView('uDeviceClusterDeviceEditListView', 'uPopupContent', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksSelectListView', 'keyFieldType': 'number', 'canUnselect': true }, lColumns);
    mInventoryControls.DeviceClusterDeviceEditListView.setDataSource(lListItems);
    mInventoryControls.DeviceClusterDeviceEditListView.selected(lAssignedIds);
}

function uEditEnrolleeListButton_OnClick() {
    "use strict";
    var lKey,
        lDevices = null,
        lDeviceIds = [],
        lAssignments = null,
        lAssignedEnrolleeIds = [],
        lButtonCommandBar = GenerateButtonCommandBar(),
        lPredicateBuilder = new SumoPredicateBuilder(),
        lListItems = null,
        lColumns = null,
        lAssignedIds = [],
        lOrganizationId;

    lPredicateBuilder.AddNewExpressionConditional('ProductId', [103, 151], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lDevices = query(getDataItems('Devices'), lPredicateBuilder.RootExpression);
    lPredicateBuilder.Clear();
    for (lKey in lDevices) {
        if (lDevices.hasOwnProperty(lKey)) {
            lDeviceIds.push(lKey);
        }
    }

    if (lDeviceIds.length > 0) {
        lPredicateBuilder.AddNewExpressionConditional('Id', lDeviceIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lAssignments = query(getDataItems('CurrentDeviceAssignments'), lPredicateBuilder.RootExpression);
        lPredicateBuilder.Clear();
        for (lKey in lAssignments) {
            if (lAssignments.hasOwnProperty(lKey)) {
                lAssignedEnrolleeIds.push(lAssignments[lKey].EnrolleeId);
            }
        }
    }
    if (lAssignedEnrolleeIds.length > 0) {
        lPredicateBuilder.AddNewExpressionConditional('Id', lAssignedEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizationId = $('#uDeviceClusterOrganizationIdEdit').val();
        if (lOrganizationId !== '') {
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        lListItems = query(getDataItems('Enrollees'), lPredicateBuilder.RootExpression);
        lPredicateBuilder.Clear();
    }
    $(GenerateButton(localizeWrapper('cOk'), '', 'uEditEnrolleeListOkButton_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), '', 'uEditEnrolleeListCancelButton_OnClick()')).appendTo(lButtonCommandBar);

    DisplayPopup(localizeWrapper('cEnrolleesEditEnrollees'), '', lButtonCommandBar, true);

    lColumns = [
        { 'id': 'Selected', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': 'SelectionColumn', 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'FullName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null, 'canResize': false },
        { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null, 'canResize': false }
    ];

    for (lKey in mInventoryData.DeviceClustersAssignedEnrolleeTempList) {
        if (mInventoryData.DeviceClustersAssignedEnrolleeTempList.hasOwnProperty(lKey)) {
            lAssignedIds.push(mInventoryData.DeviceClustersAssignedEnrolleeTempList[lKey].EnrolleeId);
        }
        var l = '';
    }

    if (!isNullOrUndefined(mInventoryControls.DeviceClusterEnrolleeEditListView)) {
        mInventoryControls.DeviceClusterEnrolleeEditListView.dispose();
        mInventoryControls.DeviceClusterEnrolleeEditListView = null;
    }
    mInventoryControls.DeviceClusterEnrolleeEditListView = new sumo.controls.ListView('uDeviceClusterOffenderEditListView', 'uPopupContent', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksSelectListView', 'keyFieldType': 'number', 'canUnselect': true }, lColumns);
    mInventoryControls.DeviceClusterEnrolleeEditListView.setDataSource(lListItems);
    mInventoryControls.DeviceClusterEnrolleeEditListView.selected(lAssignedIds);
}

function EditDeviceClusterLock_OnSuccess(aParams, aData) {
    "use strict";
    $('#uAddDeviceClusterButton').hide();
    $('#uEditDeviceClusterButton').hide();
    $('#uSaveDeviceClusterButton').show();
    $('#uCancelDeviceClusterButton').show();

    PopulateDeviceClusterEditData();

    EnterEditMode('uDeviceClusterProfilePanel');
}

function EditDeviceClusterLock_OnFailure(aParams, aData) {
    "use strict";

}

function uDeleteDeviceClusterButton_OnClick() {
    "use strict";

    var lDeviceClusterId = mInventoryData.DeviceClustersSelected,
        lDCDList = getDataItems('DeviceClusterDevices'),
        lDevices = getDataItems('Devices'),
        lDevice,
        lBuilder = new SumoPredicateBuilder(),
        lDCDWriteList = [],
        lDeviceWriteList = [],
        lItem,
        lKey;

    function deviceCluster_OnSuccess(aParams, aData) {
        setDataItem(aData.Id, 'DeviceClusters', aData);
        mInventoryControls.CardViewFilter.filter();
    }

    function device_OnSuccess(aParams, aData) {
        var lDeviceCluster = getDataItem(aParams, 'DeviceClusters');

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                setDataItem(lItem.Id, 'Devices', lItem);
            }
        }
        lDeviceCluster = $.extend({}, lDeviceCluster);
        lDeviceCluster.IsActive = false;
        lDeviceCluster.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteSingle(lDeviceCluster, deviceCluster_OnSuccess, null, aParams, true);
    }

    function dcd_OnSuccess(aParams, aData) {

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                console.log('dcd', lItem);
                setDataItem(lItem.Id, 'DeviceClusterDevices', lItem);
            }
        }
        if (aParams.DeviceList.length > 0) {
            WriteMultiple(aParams.DeviceList, device_OnSuccess, null, lDeviceClusterId, true);
        } else {
            device_OnSuccess(lDeviceClusterId, []);
        }

    }



    lBuilder.AddNewExpressionConditional('DeviceClusterId', lDeviceClusterId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lDCDList = query(lDCDList, lBuilder.RootExpression);

    for (lKey in lDCDList) {
        if (lDCDList.hasOwnProperty(lKey)) {
            lItem = lDCDList[lKey];
            lItem = $.extend({}, lItem);
            lDevice = lDevices[lItem.DeviceId];
            lDevice = $.extend({}, lDevice);
            lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            lItem.IsActive = false;
            lDCDWriteList.push(lItem);
            lDevice.Status = 5; // unassigned
            lDevice.UserId = gUserDetails.UserId;
            lDeviceWriteList.push(lDevice);
        }
    }
    if (lDCDWriteList.length > 0) {
        WriteMultiple(lDCDWriteList, dcd_OnSuccess, null, { 'DeviceList': lDeviceWriteList, 'DeviceClusterId': lDeviceClusterId }, true);
    } else {
        dcd_OnSuccess({ 'DeviceList': lDeviceWriteList, 'DeviceClusterId': lDeviceClusterId }, []);
    }
}


function uEditDeviceClusterButton_OnClick() {
    "use strict";
    var lEnrolleeList = mInventoryData.DeviceClustersAssignedEnrolleeList,
        lDevice,
        lHasBluPlusLink = false,
        lDeviceAssignmentList,
        lItem,
        lKey;


    mInventoryControls.DeviceClusterValidator = new Validator('uDeviceClusterProfilePanel', mRegexValidation);
    $('#uDeviceClusterZoneFindEdit').attr('placeholder', localizeText('cZoneZoneNameFilter'));
    mInventoryControls.DeviceClusterValidator.IsValid();
    EditDeviceClusterLock_OnSuccess(null, null);

    $('#uEditOffenderListButton').show();
    $('#uEditDeviceListButton').show();
}

function uAddDeviceClusterButton_OnClick() {
    "use strict";
    $('#uAddDeviceClusterButton').hide();
    $('#uEditDeviceClusterButton').hide();
    $('#uSaveDeviceClusterButton').show();
    $('#uCancelDeviceClusterButton').show();

    //mInventoryControls.CardView.selected(-1);
    mInventoryData.DeviceClustersLastSelectedId = mInventoryData.DeviceClustersSelected;
    mInventoryData.DeviceClustersLastSelectedDeviceList = mInventoryData.DeviceClustersAssignedDeviceList;
    mInventoryData.DeviceClustersLastSelectedEnrolleeList = mInventoryData.DeviceClustersAssignedEnrolleeList;
    mInventoryData.DeviceClustersSelected = -1;
    PopulateDeviceClusterEditData();
    EnterEditMode('uDeviceClusterProfilePanel');
    mInventoryControls.DeviceClusterValidator = new Validator('uDeviceClusterProfilePanel', mRegexValidation);
    $('#uDeviceClusterZoneFindEdit').attr('placeholder', localizeText('cZoneZoneNameFilter'));
    mInventoryControls.DeviceClusterValidator.IsValid();
    $('#uDeviceClusterProfilePanel').show();
    $('#uDeleteDeviceClusterButton').hide();
    mInventoryControls.Map.hide();
    $('#uMapPanel').hide();
}

function DeviceClusterExitEditMode() {
    "use strict";
    $('#uAddDeviceClusterButton').show();
    $('#uEditDeviceClusterButton').show();
    $('#uSaveDeviceClusterButton').hide();
    $('#uCancelDeviceClusterButton').hide();

    ExitEditMode('uDeviceClusterProfilePanel');

    //    RenderDeviceClusterDeviceListView();
    //    RenderDeviceClusterEnrolleeListView();
}

function uCancelDeviceClusterButton_OnClick() {
    "use strict";
    var lIsEmpty;
    var lDeviceCluster;
    inventoryDeviceClustersDeviceTempList_Reset();
    //mInventoryData.DeviceClustersAssignedDeviceTempList = mInventoryData.DeviceClustersAssignedDeviceList;
    inventoryDeviceClustersEnrolleeTempList_Reset();
    //mInventoryData.DeviceClustersAssignedEnrolleeTempList = mInventoryData.DeviceClustersAssignedEnrolleeList;

    DeviceClusterExitEditMode();
    if (mInventoryData.DeviceClustersSelected === -1) {
        mInventoryData.DeviceClustersSelected = mInventoryData.DeviceClustersLastSelectedId;
        mInventoryData.DeviceClustersLastSelectedId = -1;
        mInventoryData.DeviceClustersAssignedDeviceList = mInventoryData.DeviceClustersLastSelectedDeviceList;
        mInventoryData.DeviceClustersAssignedEnrolleeList = mInventoryData.DeviceClustersLastSelectedEnrolleeList;
        mInventoryData.DeviceClusterReadsRemaining += 2;
        DeviceClusterDevice_OnLoad(null, mInventoryData.DeviceClustersAssignedDeviceList);
        DeviceClusterEnrollee_OnLoad(null, mInventoryData.DeviceClustersAssignedEnrolleeList);
    }
    lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    if (lDeviceCluster) {
        if (lDeviceCluster.ZoneId < 0) {
            $('#uAssociatedZone').hide();
            if (mInventoryControls.Map)
                mInventoryControls.Map.hide();
            $('#uMapPanel').hide();
        } else {
            if (lDeviceCluster.ZoneId != $('#uDeviceClusterZoneIdEdit').val()) {
                if (mInventoryControls.Map)
                    populateDeviceClusterZone(lDeviceCluster.ZoneId);
            }
        }
    }

	lIsEmpty = (mInventoryData.DeviceClustersDirty.length === 0);
    veritracks.system.applyFilterState('InventoryDeviceClusters', lIsEmpty);
    deviceClustersDeleteButtonCheck();
}

function EditDeviceClusterUnlock_OnSuccess(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cInventoryBluBoxUnlockedSuccess'));
}

function EditDeviceClusterUnlock_OnFailure(aParams, aData) {
    "use strict";
    // mActivityNotification.addNotification('Unable to unlock BLUbox Group.');
    //  mActivityNotification.addNotification('Attempting to unlock BLUbox Group.');
    ReleaseLockSingle(gObjectList.DeviceCluster.AssemblyQualifiedName, mInventoryData.DeviceClustersSelected, EditDeviceClusterUnlock_OnSuccess, EditDeviceClusterUnlock_OnFailure, null)
}

function inventoryDeviceClustersCardView_OnRender(aSender, aObject, aData) {
    "use strict";
    mInventoryControls.CardView.unbind('databind', inventoryDeviceClustersCardView_OnRender);
    mInventoryControls.CardView.selected(aData.Id);
}

function MultipleDeviceClusterEnrolleeWrite_OnSuccess(aParams, aData) {
    "use strict";
    //    var lItem,
    //        lKey;

    //    for (lKey in aData) {
    //        if (aData.hasOwnProperty(lKey)) {
    //            lItem = aData[lKey];
    //            mInventoryData.DeviceClustersAssignedEnrolleeList[lItem.EnrolleeId] = lItem;
    //        }
    //    }
    //generateInventoryDeviceData();
    DeviceClusterExitEditMode();
    window.location.hash = 'Inventory.DeviceClusters.Device.' + aParams.Id;
    //mInventoryControls.CardView.selected(aParams.Id);
    //mInventoryControls.CardView.bind('databind', inventoryDeviceClustersCardView_OnRender, aParams);
    //mInventoryControls.CardView.setDataSource(getDataItems('DeviceClusters'));
    //populateFromEditView(lEnrolleeEdit, 'uOffenderProfile', 'Edit');
    //uDeviceClustersCardViewFilter_OnFilter();
    //mInventoryControls.CardView.setDataSource(mInventoryData.DevicesDirty);


}

function MultipleDeviceClusterDeviceWrite_OnSuccess(aParams, aData) {
    "use strict";
    //    var lItem,
    //        lKey;

    //    for (lKey in aData) {
    //        if (aData.hasOwnProperty(lKey)) {
    //            lItem = aData[lKey];
    //            mInventoryData.DeviceClustersAssignedDeviceList[lItem.EnrolleeId] = lItem;
    //        }
    //    }
    mActivityNotification.addNotification(localizeWrapper('cInventoryDeviceListSaved'));
    WriteMultiple(aParams.EnrolleeList, MultipleDeviceClusterEnrolleeWrite_OnSuccess, Sad, aParams);

    mCache.UpdateItem('DeviceClusterDevices');
    //mCache.bind('DeviceClustersupdated', testDeviceClusterDevices, null);
    //mCache.UpdateItem('DeviceClusters');
}

function inventoryDeviceClustersDeviceWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lItem,
        lKey;
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'Devices', lItem);
        }
    }
    WriteMultiple(aParams.DeviceList, MultipleDeviceClusterDeviceWrite_OnSuccess, Sad, aParams);
}

function SingleDeviceClusterWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lItem,
        lDevice,
        lDeviceWrite = [],
        lDeviceList = [],
        lTransactionId = moment().format("YYYYMMDDHHmmss"),
        lEnrolleeList = [];
    mActivityNotification.addNotification(localizeWrapper('cInventoryBluBoxGroupSave') + aData.Name);
    setDataItem(null, 'DeviceClusters', aData);
    //mActivityNotification.addNotification('Attempting to unlock BLUbox Group.');
    //ReleaseLockSingle(gObjectList.DeviceCluster.AssemblyQualifiedName, mInventoryData.DeviceClustersSelected, EditDeviceClusterUnlock_OnSuccess, EditDeviceClusterUnlock_OnFailure, null)
        
    for (lKey in mInventoryData.DeviceClustersAssignedDeviceTempList) {
        if (mInventoryData.DeviceClustersAssignedDeviceTempList.hasOwnProperty(lKey)) {
            lItem = mInventoryData.DeviceClustersAssignedDeviceTempList[lKey];
            lItem.DeviceClusterId = aData.Id;
            lItem.TransactionId = lTransactionId;
            lDeviceList.push(lItem);

            lDevice = getDataItem(lItem.DeviceId, 'Devices');
            if (lDevice) {
                lDevice = $.extend({}, lDevice);
                if (lItem.IsActive) {
                    lDevice.Status = 4;
                } else {
                    lDevice.Status = 5;
                }
                lDevice.TransactionId = lTransactionId;
                lDevice.UserId = gUserDetails.UserId;
                lDeviceWrite.push(lDevice);
            }
        }
    }
    for (lKey in mInventoryData.DeviceClustersAssignedEnrolleeTempList) {
        if (mInventoryData.DeviceClustersAssignedEnrolleeTempList.hasOwnProperty(lKey)) {
            lItem = mInventoryData.DeviceClustersAssignedEnrolleeTempList[lKey];
            lItem.DeviceClusterId = aData.Id;
            lEnrolleeList.push(lItem);
        }
    }
    //populateDeviceClusterData();
    //uDeviceClustersCardViewFilter_OnFilter();
    if (lDeviceWrite.length > 0) {
        WriteMultiple(lDeviceWrite, inventoryDeviceClustersDeviceWrite_OnSuccess, null, { 'Id': aData.Id, 'DeviceList': lDeviceList, 'EnrolleeList': lEnrolleeList }, false);
    } else {
        inventoryDeviceClustersDeviceWrite_OnSuccess({ 'Id': aData.Id, 'DeviceList': lDeviceList, 'EnrolleeList': lEnrolleeList }, []);
    }

}

function uSaveDeviceClusterButton_OnClick() {
    "use strict";

    if (mInventoryControls.DeviceClusterValidator.IsValid()) {
        var lDeviceCluster;
        DeviceClusterExitEditMode();
        $('#uSaveDeviceClusterButton').hide();
        $('#uCancelDeviceClusterButton').hide();

        if (mInventoryData.DeviceClustersSelected === -1) {
            lDeviceCluster = new DeviceCluster();
        } else {
            lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
        }
        populateFromEditView(lDeviceCluster, 'uDeviceCluster', 'Edit');
        var lTransactionId = moment().format("YYYYMMDDHHmmss");
        lDeviceCluster.TransactionId = lTransactionId;
        //Vulnerability 3251
        lDeviceCluster.Description = veritracks.system.encodeHtml(lDeviceCluster.Description);
        lDeviceCluster.Name = veritracks.system.encodeHtml(lDeviceCluster.Name);
        WriteSingle(lDeviceCluster, SingleDeviceClusterWrite_OnSuccess, Sad, ['DeviceCluster', lTransactionId]);
    }
}

function uEditDeviceListCancelButton_OnClick() {
    "use strict";
    ClosePopup();
}

function uEditDeviceListOkButton_OnClick() {
    "use strict";
    var lKey,
        lAssignment,
        lDevice,
        lItem,
        lList = {},
        lData = mInventoryControls.DeviceClusterDeviceEditListView.selected();
    for (lKey in mInventoryData.DeviceClustersAssignedDeviceTempList) {
        if (mInventoryData.DeviceClustersAssignedDeviceTempList.hasOwnProperty(lKey)) {
            lAssignment = mInventoryData.DeviceClustersAssignedDeviceTempList[lKey];
            if (!isNullOrUndefined(lAssignment)) {
                lAssignment.IsActive = false;
            }
        }
    }
    for (lKey in lData) {
        if (lData.hasOwnProperty(lKey)) {
            lDevice = GetDevice(lData[lKey]);
            if (!isNullOrUndefined(lDevice)) {
                lAssignment = mInventoryData.DeviceClustersAssignedDeviceTempList[lKey];
                if (!isNullOrUndefined(lAssignment)) {
                    lAssignment.IsActive = true;
                } else {
                    mInventoryData.DeviceClustersAssignedDeviceTempList[lDevice.Id] = new DeviceClusterDevice(mInventoryData.DeviceClustersSelected, lDevice.Id, true);
                }
                lList[lDevice.Id] = lDevice;
            }
        }
    }
    ClosePopup();
    mInventoryControls.DeviceClusterDeviceListView.setDataSource(lList);
}

function uEditEnrolleeListCancelButton_OnClick() {
    "use strict";
    ClosePopup();
}

function uEditEnrolleeListOkButton_OnClick() {
    "use strict";
    var lKey,
        lAssignment,
        lEnrollee,
        lItem,
        lList = {},
        lData = mInventoryControls.DeviceClusterEnrolleeEditListView.selected();
    for (lKey in mInventoryData.DeviceClustersAssignedEnrolleeTempList) {
        if (mInventoryData.DeviceClustersAssignedEnrolleeTempList.hasOwnProperty(lKey)) {
            lAssignment = mInventoryData.DeviceClustersAssignedEnrolleeTempList[lKey];
            if (!isNullOrUndefined(lAssignment)) {
                lAssignment.IsActive = false;
            }
        }
    }
    for (lKey in lData) {
        if (lData.hasOwnProperty(lKey)) {
            lEnrollee = GetEnrollee(lData[lKey]);
            if (!isNullOrUndefined(lEnrollee)) {
                lAssignment = mInventoryData.DeviceClustersAssignedEnrolleeTempList[lEnrollee.Id];
                if (!isNullOrUndefined(lAssignment)) {
                    lAssignment.IsActive = true;
                } else {
                    mInventoryData.DeviceClustersAssignedEnrolleeTempList[lEnrollee.Id] = new DeviceClusterEnrollee(mInventoryData.DeviceClustersSelected, lEnrollee.Id, true);
                }
                lList[lEnrollee.Id] = lEnrollee;
                //mInventoryData.DeviceClustersAssignedEnrolleeList[lKey] = lItem;
            }
        }
    }
    ClosePopup();
    mInventoryControls.DeviceClusterEnrolleeListView.setDataSource(lList);
    //mDeviceClusterEnrolleeEditListView.RenderContents(false);
}
function zonefiltername() {
    var lValue = $('#uDeviceClusterZoneFindEdit').val();
    var lOrganizationId = $('#uDeviceClusterOrganizationIdEdit').val();
    if (lValue) {
        populateDeviceClusterZonesDropdownFilter(lValue, lOrganizationId);
    } else {
        populateDeviceClusterZonesDropDown(lOrganizationId);
    }

}

function uDeviceClusterOrganizationIdEdit_OnChange(aSelect) {
    "use strict";
    var lOrganizationId = $(aSelect).val(),
        lAssignment,
        lKey;
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);

    $('#uDeviceClusterZoneFindEdit').val("");
    if (lDeviceCluster && lOrganizationId != lDeviceCluster.OrganizationId) {
        for (lKey in mInventoryData.DeviceClustersAssignedEnrolleeTempList) {
            if (mInventoryData.DeviceClustersAssignedEnrolleeTempList.hasOwnProperty(lKey)) {
                lAssignment = mInventoryData.DeviceClustersAssignedEnrolleeTempList[lKey];
                if (!isNullOrUndefined(lAssignment)) {
                    lAssignment.IsActive = false;
                }
            }
        }
        mInventoryControls.DeviceClusterEnrolleeListView.setDataSource([]);

        for (lKey in mInventoryData.DeviceClustersAssignedDeviceTempList) {
            if (mInventoryData.DeviceClustersAssignedDeviceTempList.hasOwnProperty(lKey)) {
                lAssignment = mInventoryData.DeviceClustersAssignedDeviceTempList[lKey];
                if (!isNullOrUndefined(lAssignment)) {
                    lAssignment.IsActive = false;
                }
            }
        }

        mInventoryControls.DeviceClusterDeviceListView.setDataSource([]);
    }
    populateDeviceClusterZonesDropDown(lOrganizationId);
}

function populateDeviceClusterZonesDropdownFilter(aFilterName, aOrganizationId) {
    "use strict";
    var lZones = ZonesSortFormatter(GetZones(aOrganizationId, 1, 1, aFilterName));
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    var lPastId = $("#uDeviceClusterZoneIdEdit").val();
    populateEditView([], [{ 'Id': 'ZoneId', 'Type': 'Dropdown', 'DataSource': lZones, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': true, 'nullText': localizeText('cZoneNoZoneSelected'), 'nullValue': '-1' }], {}, 'uDeviceCluster', 'Edit');

    $("#uDeviceClusterZoneIdEdit").val(lPastId); // save state so that it does not refresh map.
    if ($("#uDeviceClusterZoneIdEdit option:eq(1)").val() != $("#uDeviceClusterZoneIdEdit").val() || !mInventoryControls.Map.IsControlVisible) {
        $("#uDeviceClusterZoneIdEdit").val($("#uDeviceClusterZoneIdEdit option:eq(1)").val());
        $('#uDeviceClusterZoneIdEdit').change();
    }
}

function populateDeviceClusterZonesDropDown(aOrganizationId) {
    "use strict";
    var lZones = ZonesSortFormatter(GetZones(aOrganizationId, 1, 1));
    var lDeviceCluster = GetDeviceCluster(mInventoryData.DeviceClustersSelected);
    populateEditView([], [{ 'Id': 'ZoneId', 'Type': 'Dropdown', 'DataSource': lZones, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': true, 'nullText': localizeText('cZoneNoZoneSelected'), 'nullValue': '-1' }], {}, 'uDeviceCluster', 'Edit');

    if (lDeviceCluster) {
        if (lDeviceCluster.OrganizationId == aOrganizationId) {
            $('#uDeviceClusterZoneIdEdit').val(lDeviceCluster.ZoneId);
        } else {
            $("#uDeviceClusterZoneIdEdit").val($("#uDeviceClusterZoneIdEdit option:first").val());
        }
    }
    $('#uDeviceClusterZoneIdEdit').change();
}

function uDeviceClusterZoneIdEdit_OnChange(aSelect) {
    "use strict";
    var lZoneId = $(aSelect).val();
    populateDeviceClusterZone(lZoneId);
}

//-----------
// Generators
//-----------

function DeviceClusterTitleCellGenerator(aDeviceCluster) {
    "use strict";
    var lMasterDiv = $('<div/>', {}).attr('RowId', aDeviceCluster.Id),
        lNameDiv = $("<div/>", {
            'text': aDeviceCluster.Name
        }).attr('RowId', aDeviceCluster.Id),
        lDescriptionDiv = $("<div/>", {
            'text': aDeviceCluster.Description
        }).attr('RowId', aDeviceCluster.Id);

    lNameDiv.appendTo(lMasterDiv);
    lDescriptionDiv.appendTo(lMasterDiv);

    return lMasterDiv;
}

function DeviceUniversalSearchGenerator(aDataItem) {
    "use strict";
    return aDataItem.SerialNumber + ' (' + ProductNameFormatter(aDataItem.ProductId) + ')';
}

function DeviceClusterStatsCellGenerator(aDeviceCluster) {
    "use strict";
    // POPULATE
}

//------------
// Data Access
//------------
function getDeviceLastContact(aDeviceId) {
    "use strict";
    var lResult = null,
        lLastContact = gDeviceLastContact[aDeviceId];

    if (!isNullOrUndefined(lLastContact)) {
        lResult = lLastContact;
    } else {
        //lResult = new LastContact();
    }
    return lResult;
}

//function GetLastContact(aDeviceId) {
//    var lResult = null,
//        lLastContact = gLastContact[aDeviceId];

//    if (typeof lLastContact !== 'undefined' && lLastContact !== null) {
//        lResult = lLastContact;
//    } else {
//        lResult = new LastContact();
//    }

//    return lResult;
//}

function GetKnownLocation(aId) {
    "use strict";
    var lResult = null,
    lKnownLocation = getDataItem(aId, 'OrganizationAddress');

    if (typeof lKnownLocation !== 'undefined' && lKnownLocation !== null) {
        lResult = lKnownLocation;
    }
    return lResult;
}

function GetDeviceCluster(aId) {
    "use strict";
    var lResult = null,
        lDeviceCluster = getDataItem(aId, 'DeviceClusters');

    if (typeof lDeviceCluster !== 'undefined' && lDeviceCluster !== null) {
        lResult = lDeviceCluster;
    }
    return lResult;
}

//Distance Tool
function inventoryDistanceToolBar_OnClick() {
    "use strict";
    if (mInventoryData.DistanceToolActive === false) {
        mInventoryData.DistanceToolActive = true;
        $('#uDistanceToolHolder').removeClass('DistanceToolBarButton').addClass('DistanceToolBarButtonActive');
    } else {
        mInventoryData.DistanceToolActive = false;
        $('#uDistanceToolHolder').addClass('DistanceToolBarButton').removeClass('DistanceToolBarButtonActive');
        mInventoryData.DistancePoints = [];
        mInventoryControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
        mInventoryControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
        mInventoryControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
    }
}

function inventoryCalculateDistance_OnComplete(aDistance, aLatitude, aLongitude) {
    "use strict";
    mInventoryControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([{ 'latitude': aLatitude, 'longitude': aLongitude, 'text': aDistance }]));
    mInventoryControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData(mInventoryData.DistancePoints));
}

function inventoryCalculateDistance_OnClick(aClickData) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));

    if (lDoMetric) {
        inventoryCalculateDistance(aClickData, new Unit().MEASURE.METRIC);
    } else {
        inventoryCalculateDistance(aClickData);
    }
}
function inventoryCalculateDistance(aClickData, aUnit) {
    "use strict";
    var lLatitude = aClickData.latLng.lat(),
        lLongitude = aClickData.latLng.lng(),
        lResult,
        lCard;
    if (mInventoryData.DistanceToolActive === true) {
        if (!isNullOrUndefined(lLatitude) && !isNullOrUndefined(lLongitude)) {
            if (mInventoryData.DistancePoints.length >= 2) {
                mInventoryData.DistancePoints = [];
                mInventoryControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
                mInventoryControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
                mInventoryControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
            }
            lCard = new DistanceCard();
            lCard.latitude = lLatitude;
            lCard.longitude = lLongitude;
            if (isNullOrUndefined(mInventoryData.DistancePoints)) {
                mInventoryData.DistancePoints.push(lCard);
            } else {
                mInventoryData.DistancePoints.push(lCard);
            }
            if (mInventoryData.DistancePoints.length > 1) {
                if (isNullOrUndefined(aUnit)) {
                    lResult = veritracks.mapping.calculateDistances(mInventoryData.DistancePoints[0].latitude, mInventoryData.DistancePoints[0].longitude, mInventoryData.DistancePoints[1].latitude, mInventoryData.DistancePoints[1].longitude, 'inventory');
                } else {
                    if (aUnit.name == "Metric") {
                        lResult = veritracks.mapping.calculateDistancesMetric(mInventoryData.DistancePoints[0].latitude, mInventoryData.DistancePoints[0].longitude, mInventoryData.DistancePoints[1].latitude, mInventoryData.DistancePoints[1].longitude, 'inventory');
                    } else {
                        lResult = veritracks.mapping.calculateDistances(mInventoryData.DistancePoints[0].latitude, mInventoryData.DistancePoints[0].longitude, mInventoryData.DistancePoints[1].latitude, mInventoryData.DistancePoints[1].longitude, 'inventory');
                    }
                }
                inventoryCalculateDistance_OnComplete(lResult.distanceDisplay, lResult.endPoint.latitude, lResult.endPoint.longitude);
            }
            mInventoryControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData(mInventoryData.DistancePoints));
        }
    }
}

// iphone resolution handlers
function inventoryMapPanel_OnClick() {
    "use strict";
    var lMasterWidth = $(window).width();
    //if ($('#uInventoryListCell').css('display') == 'none') {
    //    mInventoryDisplay = true;
    //}
    //else {
    //    mInventoryDisplay = false
    //}
    resetContentHoldersInventory(lMasterWidth);
}

function inventoryIphoneResolution() {
    "use strict";
    var lPanelWidth,
        lDeviceDetailWidth,
        lListWidth;

    $('#uPrimaryMapCollapsePanel').show('fast');

    if (mStateManager.Settings()[0] === 'Devices') {
        lPanelWidth = $('#uInventoryMainContentPanel').width();
        if (mStateManager.Settings()[1] === 'Device') {
            lDeviceDetailWidth = $('#uDeviceDetailTable').width();
            setWidth('#uMapPanel', lPanelWidth - (lDeviceDetailWidth + 10));
        }
        else if (mStateManager.Settings()[1] === 'AssignmentHistory') {
            setWidth('#uAssignmentHistoryListView', lPanelWidth);
        }
        else if (mStateManager.Settings()[1] === 'ContactHistory') {
            setWidth('#uDeviceContactListView', lPanelWidth);
        }
        mPreviousPanelWidth = lPanelWidth;
    }
    else {
        lPanelWidth = $('#uInventoryMainContentPanel').width();
        lListWidth = $('#uInventoryListCell').width();
        $('#uDeviceClusterProfileHolder').css('display', 'block');
        setWidth('#uDeviceClusterDeviceListViewHolder', 300);
        setWidth('#uDeviceClusterEnrolleeListViewHolder', 300);
        if ($('#uInventoryListCell').css('display') == 'none') {
            setWidth('#uDeviceClusterProfileHolder', lPanelWidth - lListWidth);
        }
        else {
            setWidth('#uDeviceClusterProfileHolder', mPreviousPanelWidth - 10);
        }
    }
}

function resetContentLargeViewInventory() {
    setWidth('#uInventoryListPanel', 350);
    $('#uPrimaryMapCollapsePanel').hide();
    $('#uInventoryListCell').show('fast');


    var lPanelWidth = $('#uInventoryMainContentPanel').width(),
        lDeviceDetailWidth = $('#uDeviceDetailTable').width();

    setWidth('#uMapPanel', lPanelWidth - (lDeviceDetailWidth + 10));
    setWidth('#uAssignmentHistoryListView', lPanelWidth);
    setWidth('#uDeviceContactListView', lPanelWidth);
    $('#uDeviceClusterProfileHolder').css('display', 'table');
    setWidth('#uDeviceClusterDeviceListViewHolder', 350);
    setWidth('#uDeviceClusterEnrolleeListViewHolder', 350);
}


function zonesKnownLocationMapShape_OnChange(aShape) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    var lZoneRadius;

    //mInventoryData.KnownLocationEditData.Latitude = aShape.center.lat();
    //mInventoryData.KnownLocationEditData.Longitude = aShape.center.lng();

    if (lDoMetric) {
        lZoneRadius = aShape.radius;
    }
    else {
        lZoneRadius = convertMetersToFeet(aShape.radius);
    }

    $('#uKnownLocationRadiusEdit').val(Math.round(lZoneRadius));
}


function zonesKnownLocationMapRadius_OnClick() {
    "use strict";
    var lZoneRadiusInput = $('#uKnownLocationRadiusEdit').val();
    var lZone = new Zone();
    var lOldShape = mInventoryControls.Map.layerGetShape('KnownZones', mInventoryData.EditShape.sumoId);

    lZone.Type = 1;

    lZone.CenterLatitude = lOldShape.center.lat();
    lZone.CenterLongitude = lOldShape.center.lng();
    lZone.Radius = parseFloat(lZoneRadiusInput);
    lZone.Id = mInventoryData.KnownLocationEditData.Id;

    mInventoryControls.Map.layerSetDataSource('KnownZones', veritracks.mapping.prepareZoneData([lZone]));
    mInventoryData.EditShape = mInventoryControls.Map.layerGetShape('KnownZones', lZone.Id);
    if (!isNullOrUndefined(mInventoryData.EditShape)) {
        mInventoryData.EditShape.setEditable(true);
    }
    mInventoryData.Map.fitBounds();
}


function getVoltageLabels() {
    var lMomentArray = [];
    var lMoment;
    var lStartDate = mInventoryData.BatteryDate;
    for (var i = 0; i <= 23; i++) {
        lMoment = moment(lStartDate);
        lMoment.hour(i);
        lMoment.minute(0);
        lMoment.second(0);

        lMomentArray.push(lMoment.format(mInventoryData.BatteryDateFormat));
    }

    lMoment = moment(lStartDate);
    lMoment.hour(23);
    lMoment.minute(59);
    lMoment.second(59);

    lMomentArray.push(lMoment.format(mInventoryData.BatteryDateFormat));


    return lMomentArray;
}

function getPointColor(aType) {
    //WHEN dt.CHARGER_CONN     = 'Y' THEN 'charging' --Order is critical
    //WHEN dt.BATTERY_CRITICAL = 'Y' THEN 'critical'
    //WHEN dt.BATTERY_WARNING  = 'Y' THEN 'warning'
    //WHEN dt.BATTERY_LOW      = 'Y' THEN 'low'
    //ELSE                             'normal'

    //charging => [ 63, 63,251],
    //critical => [255,  0,  0],
    //warning  => [255,165,  0],
    //low      => [242,242, 32],
    //normal   => [  0,  0,  0],
    switch (aType) {
        case "charging":
            return "rgb(63,63,251)";
            break;
        case "critical":
            return "rgb(255,0,0)";
            break;
        case "warning":
            return "rgb(255,165,0)";
            break;
        case "low":
            return "rgb(242,242,32)";
            break;
        case "normal":
            return "rgb(0,0,0)";
            break;
    }
    return "blue";
}


function BatteryDate_OnChange() {
    "use strict";
    var lDateValue = $('#uBatteryDatePicker').val();

    $('#uBatteryDatePicker').val(lDateValue);
    mInventoryData.BatteryDate = moment(lDateValue);
    populateLineChart();
}

function uDeviceBatteryChart_Init() {
    "use strict";
    if (!mInventoryControls.chartInstance) {
        initiateBatteryVoltageChart();
    }
    if (mInventoryData.BatteryDate == null) {
        mInventoryData.BatteryDate = moment();
    }
    $('#uBatteryDatePicker').val(displayShortDate(mInventoryData.BatteryDate._d));
    populateDateView('#uBatteryDatePicker', BatteryDate_OnChange);
    if (mInventoryData.DevicesSelectedIds.length === 0) {
        //SelectFirstDeviceItem(mInventoryControls.DevicesCardView, uDeviceContactListView_Init);
        mInventoryControls.DevicesCardView.selectedIndex(0);
    } else {
        populateLineChart();
    }
}

function initiateBatteryVoltageChart() {
    "use strict";
    var ctx = document.getElementById("myCanvas");

    mInventoryControls.chartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: getVoltageLabels(),
                datasets: [{
                    type: 'line',
                    data: [],
                    radius: 1,
                    pointBorderColor: [],
                    backgroundColor: "rgba(151,187,205,0)"
                }]
            },
            options: {
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                showLines: true,
                title: {
                    display: true,
                    text: "battery voltage chart"
                },
                scales: {
                    xAxes: [{
                        time: {
                            unit: "hour"
                        },
                        type: "time",
                        scaleLabel: {
                            display: true
                        }
                    }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Voltage (V)'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 3.6,
                            max: 4.3,
                            stepSize: 0.2
                        }
                    }]
                },
            }
        })
}
function batteryLegend() {
    "use strict";
    var lHtml = [];
    lHtml.push('<div id="uVeritracksCalendarLegend style="width:200px;">');
    //charging => [ 63, 63,251],
    //critical => [255,  0,  0],
    //warning  => [255,165,  0],
    //low      => [242,242, 32],
    //normal   => [  0,  0,  0],
    lHtml.push(LegendIconDisplay('VeritracksInclusionZoneSchedule', "Charging", "rgb(63,63,251)"));
    lHtml.push(LegendIconDisplay('VeritracksInclusionZoneScheduleOverride', "Critical", "rgb(255,  0,  0)"));
    lHtml.push(LegendIconDisplay('VeritracksDayChecInSchedule', "Warning", "rgb(255,165,  0)"));
    lHtml.push(LegendIconDisplay('VeritracksDayRegularSchedule', "Low", "rgb(242,242, 32)"));
    lHtml.push(LegendIconDisplay('VeritracksDayRegularScheduleOverride', "Normal", "rgb(0, 0, 0)"));

    lHtml.push('</div>');
    DisplayModal("Device Battery Status", lHtml.join(''), null, null);
}

function batteryChartDownload() {
    "use strict";
    var canvas = document.getElementById("myCanvas");

    canvas.toBlob(function (blob) {
        saveAs(blob, "voltage_chart");
    });
}

function populateLineChart() {
    "use strict";
    var lDevice = mInventoryControls.DevicesCardView.selectedDataItem();
    var lMoment = mInventoryData.BatteryDate;


    if (mInventoryControls.chartInstance) {
        mInventoryControls.chartInstance.data.datasets[0].data = [];
        mInventoryControls.chartInstance.data.datasets[0].pointBorderColor = [];
        mInventoryControls.chartInstance.options.title.text = "";
        mInventoryControls.chartInstance.update();
        mInventoryControls.chartInstance.resize();
    }
    if (lDevice) {
        veritracks.data.controller.readDeviceBattery(lDevice.Id, lMoment.month(), lMoment.date(), lMoment.year(), buildLineChart, Sad);
    }
    function buildLineChart(aParams, aData) {
        var xyHolder = [];
        var colorholder = [];
        var lDateFormat = lMoment.format('MM/DD/YYYY');

        if (aData.length == 0) {
            mActivityNotification.addNotification('No Battery voltage data found for this day');
        }
        if (!isNullOrUndefined(mInventoryControls.chartInstance)) {
            mInventoryControls.chartInstance.destroy();
        }
        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                xyHolder.push(
                    {
                        x: moment(aData[lKey].EpochString).format(mInventoryData.BatteryDateFormat),
                        y: aData[lKey].Voltage
                    });
                colorholder.push(getPointColor(aData[lKey].Color));
            }
        }

        mInventoryControls.chartInstance.data.datasets[0].data = xyHolder;
        mInventoryControls.chartInstance.data.datasets[0].pointBorderColor = colorholder;
        mInventoryControls.chartInstance.data.labels = getVoltageLabels();
        mInventoryControls.chartInstance.options.title.text = "Device Battery Voltage - Device: " + lDevice.SerialNumber + " - Date: " + lDateFormat;

        //retina display needs to be taken care of.
        if (isRetinaDisplay()) {
            var lCanvas = document.getElementById('myCanvas');
            lCanvas.getContext('2d').scale(2, 2);
        }

        mInventoryControls.chartInstance.update();
    }
}


function deviceRefreshStatus_OnClick(aDeviceStatus){
    "use strict";
    const lHtml =`
        <div style="width:100%;text-align:center;">
            <p>${deviceRefreshStatusPopupTextFormatter(aDeviceStatus)}</p> 
        </div>
    `;
    const lButtonBar = GenerateButtonCommandBar();
    GenerateButton('Close', 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup(localizeText('cAgentWarning'),lHtml, lButtonBar, null, true)

}